import { j as n } from "./jsx-runtime-C5mzlN2N.js";
import { ChevronDown as yt, ChevronUp as wn, Check as vt, ChevronUpIcon as Cn, ChevronRightIcon as Sn, CheckIcon as bt, DotIcon as Tn, PlusCircleIcon as fe, FileInput as An, TableOfContentsIcon as On, LockIcon as Rn, CircleAlertIcon as Pn, XIcon as jt, Circle as Ln, Unlink2Icon as $n, CornerDownRightIcon as En, CornerDownLeftIcon as In, DownloadIcon as kn, UnplugIcon as Dn, SendIcon as zn, CopyIcon as Fn, IdCardLanyardIcon as qn, ShapesIcon as Vn, LogInIcon as Bn, CirclePlayIcon as _n } from "lucide-react";
import { r as Un, c as Mn, u as Gn, N as Hn, g as Qn, m as ot } from "./chunk-DQRVZFIR-DHK7_Ilc.js";
import { o as $e, p as Ee, q as Nt, d as Jn, l as Wn, r as Xn, j as I, c as Zn, e as Yn } from "./hook-CZjW2buS.js";
import { Button as re } from "./ui/Button.js";
import { Z as Kn, i as es } from "./invariant-DAFpPywt.js";
import * as w from "react";
import { createContext as wt, use as ts, useRef as L, useEffect as z, useMemo as Ct, useState as k, useCallback as St, Fragment as ee, useLayoutEffect as ns, useTransition as ss, useContext as rs } from "react";
import { VisuallyHidden as as } from "@radix-ui/react-visually-hidden";
import { D as Ie, a as ke, b as De, d as Tt, f as At, e as os } from "./Dialog-DMWw1doX.js";
import { S as is, a as cs } from "./index-D09PbNex.js";
import { A as ls, a as ds, b as us, u as ms } from "./Alert-CWApD0CL.js";
import { u as ie, a as ze, C as F, b as ps, F as hs } from "./index.esm-Cp4wkyud.js";
import { B as E } from "./Button-B3o-2Xdf.js";
import * as Fe from "@radix-ui/react-collapsible";
import * as S from "@radix-ui/react-select";
import { c as v } from "./cn-dYga0KKN.js";
import { b as it, c as ct, d as lt, f as fs } from "./Slot-B31yZlfB.js";
import { u as xs } from "./CodeBlock-B-G0eKtw.js";
import { u as gs } from "./RouteGuard-Vnlz_t51.js";
import * as C from "@radix-ui/react-dropdown-menu";
import * as Re from "@radix-ui/react-checkbox";
import * as ue from "@radix-ui/react-popover";
import { PopoverAnchor as ys } from "@radix-ui/react-popover";
import { P as vs } from "./index-CrcNWbel.js";
import { f as bs, g as js, C as Ns, b as ws } from "./Command-C9AC5cf-.js";
import { Input as me } from "./ui/Input.js";
import { Slot as Cs } from "@radix-ui/react-slot";
import { C as Ss } from "./Card-CMDQUPM4.js";
import * as Ot from "@radix-ui/react-label";
import { c as Ts } from "./index-DI5SPFK9.js";
import * as ae from "@radix-ui/react-radio-group";
import { z as As } from "./index-Bm35Tkgf.js";
import { h as Os } from "./SyntaxHighlight-bm761HDo.js";
let Ne;
const Rs = (e) => {
  if (e.errors?.[0])
    throw new Kn(e.errors[0].message, {
      developerHint: "Check your configuration value `apis.type` and `apis.input` in the Zudoku config."
    });
};
class Ps {
  constructor(t) {
    this.config = t;
  }
  #e = async () => (Ne || (Ne = import("./createServer-DNyGJJNX.js").then(
    (t) => t.createServer(this.config)
  )), Ne);
  #t = async (t) => this.config.server ? fetch(this.config.server, t) : (await this.#e()).fetch("http://localhost/graphql", t);
  fetch = async (t, s) => {
    const a = t.match(/query (\w+)/)?.[1], r = await this.#t({
      method: "POST",
      body: JSON.stringify({ query: t, variables: s, operationName: a }),
      headers: { "Content-Type": "application/json" }
    });
    if (!r.ok)
      throw new Error("Network response was not ok");
    const o = await r.json();
    return Rs(o), o.data;
  };
}
function we(e, t) {
  if (!!!e)
    throw new Error(t);
}
function Ls(e) {
  return typeof e == "object" && e !== null;
}
function $s(e, t) {
  if (!!!e)
    throw new Error(
      t ?? "Unexpected invariant triggered."
    );
}
const Es = /\r\n|[\n\r]/g;
function Pe(e, t) {
  let s = 0, a = 1;
  for (const r of e.body.matchAll(Es)) {
    if (typeof r.index == "number" || $s(!1), r.index >= t)
      break;
    s = r.index + r[0].length, a += 1;
  }
  return {
    line: a,
    column: t + 1 - s
  };
}
function Is(e) {
  return Rt(
    e.source,
    Pe(e.source, e.start)
  );
}
function Rt(e, t) {
  const s = e.locationOffset.column - 1, a = "".padStart(s) + e.body, r = t.line - 1, o = e.locationOffset.line - 1, i = t.line + o, l = t.line === 1 ? s : 0, c = t.column + l, u = `${e.name}:${i}:${c}
`, d = a.split(/\r\n|[\n\r]/g), h = d[r];
  if (h.length > 120) {
    const f = Math.floor(c / 80), m = c % 80, x = [];
    for (let y = 0; y < h.length; y += 80)
      x.push(h.slice(y, y + 80));
    return u + dt([
      [`${i} |`, x[0]],
      ...x.slice(1, f + 1).map((y) => ["|", y]),
      ["|", "^".padStart(m)],
      ["|", x[f + 1]]
    ]);
  }
  return u + dt([
    // Lines specified like this: ["prefix", "string"],
    [`${i - 1} |`, d[r - 1]],
    [`${i} |`, h],
    ["|", "^".padStart(c)],
    [`${i + 1} |`, d[r + 1]]
  ]);
}
function dt(e) {
  const t = e.filter(([a, r]) => r !== void 0), s = Math.max(...t.map(([a]) => a.length));
  return t.map(([a, r]) => a.padStart(s) + (r ? " " + r : "")).join(`
`);
}
function ks(e) {
  const t = e[0];
  return t == null || "kind" in t || "length" in t ? {
    nodes: t,
    source: e[1],
    positions: e[2],
    path: e[3],
    originalError: e[4],
    extensions: e[5]
  } : t;
}
class qe extends Error {
  /**
   * An array of `{ line, column }` locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */
  /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */
  /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */
  /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */
  /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */
  /**
   * The original error thrown from a field resolver during execution.
   */
  /**
   * Extension fields to add to the formatted error.
   */
  /**
   * @deprecated Please use the `GraphQLErrorOptions` constructor overload instead.
   */
  constructor(t, ...s) {
    var a, r, o;
    const { nodes: i, source: l, positions: c, path: u, originalError: d, extensions: h } = ks(s);
    super(t), this.name = "GraphQLError", this.path = u ?? void 0, this.originalError = d ?? void 0, this.nodes = ut(
      Array.isArray(i) ? i : i ? [i] : void 0
    );
    const f = ut(
      (a = this.nodes) === null || a === void 0 ? void 0 : a.map((x) => x.loc).filter((x) => x != null)
    );
    this.source = l ?? (f == null || (r = f[0]) === null || r === void 0 ? void 0 : r.source), this.positions = c ?? f?.map((x) => x.start), this.locations = c && l ? c.map((x) => Pe(l, x)) : f?.map((x) => Pe(x.source, x.start));
    const m = Ls(
      d?.extensions
    ) ? d?.extensions : void 0;
    this.extensions = (o = h ?? m) !== null && o !== void 0 ? o : /* @__PURE__ */ Object.create(null), Object.defineProperties(this, {
      message: {
        writable: !0,
        enumerable: !0
      },
      name: {
        enumerable: !1
      },
      nodes: {
        enumerable: !1
      },
      source: {
        enumerable: !1
      },
      positions: {
        enumerable: !1
      },
      originalError: {
        enumerable: !1
      }
    }), d != null && d.stack ? Object.defineProperty(this, "stack", {
      value: d.stack,
      writable: !0,
      configurable: !0
    }) : Error.captureStackTrace ? Error.captureStackTrace(this, qe) : Object.defineProperty(this, "stack", {
      value: Error().stack,
      writable: !0,
      configurable: !0
    });
  }
  get [Symbol.toStringTag]() {
    return "GraphQLError";
  }
  toString() {
    let t = this.message;
    if (this.nodes)
      for (const s of this.nodes)
        s.loc && (t += `

` + Is(s.loc));
    else if (this.source && this.locations)
      for (const s of this.locations)
        t += `

` + Rt(this.source, s);
    return t;
  }
  toJSON() {
    const t = {
      message: this.message
    };
    return this.locations != null && (t.locations = this.locations), this.path != null && (t.path = this.path), this.extensions != null && Object.keys(this.extensions).length > 0 && (t.extensions = this.extensions), t;
  }
}
function ut(e) {
  return e === void 0 || e.length === 0 ? void 0 : e;
}
function $(e, t, s) {
  return new qe(`Syntax Error: ${s}`, {
    source: e,
    positions: [t]
  });
}
class Ha {
  /**
   * The character offset at which this Node begins.
   */
  /**
   * The character offset at which this Node ends.
   */
  /**
   * The Token at which this Node begins.
   */
  /**
   * The Token at which this Node ends.
   */
  /**
   * The Source document the AST represents.
   */
  constructor(t, s, a) {
    this.start = t.start, this.end = s.end, this.startToken = t, this.endToken = s, this.source = a;
  }
  get [Symbol.toStringTag]() {
    return "Location";
  }
  toJSON() {
    return {
      start: this.start,
      end: this.end
    };
  }
}
class Pt {
  /**
   * The kind of Token.
   */
  /**
   * The character offset at which this Node begins.
   */
  /**
   * The character offset at which this Node ends.
   */
  /**
   * The 1-indexed line number on which this Token appears.
   */
  /**
   * The 1-indexed column number at which this Token begins.
   */
  /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   *
   * Note: is undefined for punctuation tokens, but typed as string for
   * convenience in the parser.
   */
  /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */
  constructor(t, s, a, r, o, i) {
    this.kind = t, this.start = s, this.end = a, this.line = r, this.column = o, this.value = i, this.prev = null, this.next = null;
  }
  get [Symbol.toStringTag]() {
    return "Token";
  }
  toJSON() {
    return {
      kind: this.kind,
      value: this.value,
      line: this.line,
      column: this.column
    };
  }
}
const Ds = {
  Name: [],
  Document: ["definitions"],
  OperationDefinition: [
    "name",
    "variableDefinitions",
    "directives",
    "selectionSet"
  ],
  VariableDefinition: ["variable", "type", "defaultValue", "directives"],
  Variable: ["name"],
  SelectionSet: ["selections"],
  Field: ["alias", "name", "arguments", "directives", "selectionSet"],
  Argument: ["name", "value"],
  FragmentSpread: ["name", "directives"],
  InlineFragment: ["typeCondition", "directives", "selectionSet"],
  FragmentDefinition: [
    "name",
    // Note: fragment variable definitions are deprecated and will removed in v17.0.0
    "variableDefinitions",
    "typeCondition",
    "directives",
    "selectionSet"
  ],
  IntValue: [],
  FloatValue: [],
  StringValue: [],
  BooleanValue: [],
  NullValue: [],
  EnumValue: [],
  ListValue: ["values"],
  ObjectValue: ["fields"],
  ObjectField: ["name", "value"],
  Directive: ["name", "arguments"],
  NamedType: ["name"],
  ListType: ["type"],
  NonNullType: ["type"],
  SchemaDefinition: ["description", "directives", "operationTypes"],
  OperationTypeDefinition: ["type"],
  ScalarTypeDefinition: ["description", "name", "directives"],
  ObjectTypeDefinition: [
    "description",
    "name",
    "interfaces",
    "directives",
    "fields"
  ],
  FieldDefinition: ["description", "name", "arguments", "type", "directives"],
  InputValueDefinition: [
    "description",
    "name",
    "type",
    "defaultValue",
    "directives"
  ],
  InterfaceTypeDefinition: [
    "description",
    "name",
    "interfaces",
    "directives",
    "fields"
  ],
  UnionTypeDefinition: ["description", "name", "directives", "types"],
  EnumTypeDefinition: ["description", "name", "directives", "values"],
  EnumValueDefinition: ["description", "name", "directives"],
  InputObjectTypeDefinition: ["description", "name", "directives", "fields"],
  DirectiveDefinition: ["description", "name", "arguments", "locations"],
  SchemaExtension: ["directives", "operationTypes"],
  ScalarTypeExtension: ["name", "directives"],
  ObjectTypeExtension: ["name", "interfaces", "directives", "fields"],
  InterfaceTypeExtension: ["name", "interfaces", "directives", "fields"],
  UnionTypeExtension: ["name", "directives", "types"],
  EnumTypeExtension: ["name", "directives", "values"],
  InputObjectTypeExtension: ["name", "directives", "fields"]
}, zs = new Set(Object.keys(Ds));
function Qa(e) {
  const t = e?.kind;
  return typeof t == "string" && zs.has(t);
}
var mt;
(function(e) {
  e.QUERY = "query", e.MUTATION = "mutation", e.SUBSCRIPTION = "subscription";
})(mt || (mt = {}));
function Le(e) {
  return e === 9 || e === 32;
}
function oe(e) {
  return e >= 48 && e <= 57;
}
function Lt(e) {
  return e >= 97 && e <= 122 || // A-Z
  e >= 65 && e <= 90;
}
function $t(e) {
  return Lt(e) || e === 95;
}
function Fs(e) {
  return Lt(e) || oe(e) || e === 95;
}
function qs(e) {
  var t;
  let s = Number.MAX_SAFE_INTEGER, a = null, r = -1;
  for (let i = 0; i < e.length; ++i) {
    var o;
    const l = e[i], c = Vs(l);
    c !== l.length && (a = (o = a) !== null && o !== void 0 ? o : i, r = i, i !== 0 && c < s && (s = c));
  }
  return e.map((i, l) => l === 0 ? i : i.slice(s)).slice(
    (t = a) !== null && t !== void 0 ? t : 0,
    r + 1
  );
}
function Vs(e) {
  let t = 0;
  for (; t < e.length && Le(e.charCodeAt(t)); )
    ++t;
  return t;
}
function Bs(e, t) {
  const s = e.replace(/"""/g, '\\"""'), a = s.split(/\r\n|[\n\r]/g), r = a.length === 1, o = a.length > 1 && a.slice(1).every((m) => m.length === 0 || Le(m.charCodeAt(0))), i = s.endsWith('\\"""'), l = e.endsWith('"') && !i, c = e.endsWith("\\"), u = l || c, d = !(t != null && t.minimize) && // add leading and trailing new lines only if it improves readability
  (!r || e.length > 70 || u || o || i);
  let h = "";
  const f = r && Le(e.charCodeAt(0));
  return (d && !f || o) && (h += `
`), h += s, (d || u) && (h += `
`), '"""' + h + '"""';
}
var g;
(function(e) {
  e.SOF = "<SOF>", e.EOF = "<EOF>", e.BANG = "!", e.DOLLAR = "$", e.AMP = "&", e.PAREN_L = "(", e.PAREN_R = ")", e.SPREAD = "...", e.COLON = ":", e.EQUALS = "=", e.AT = "@", e.BRACKET_L = "[", e.BRACKET_R = "]", e.BRACE_L = "{", e.PIPE = "|", e.BRACE_R = "}", e.NAME = "Name", e.INT = "Int", e.FLOAT = "Float", e.STRING = "String", e.BLOCK_STRING = "BlockString", e.COMMENT = "Comment";
})(g || (g = {}));
class _s {
  /**
   * The previously focused non-ignored token.
   */
  /**
   * The currently focused non-ignored token.
   */
  /**
   * The (1-indexed) line containing the current token.
   */
  /**
   * The character offset at which the current line begins.
   */
  constructor(t) {
    const s = new Pt(g.SOF, 0, 0, 0, 0);
    this.source = t, this.lastToken = s, this.token = s, this.line = 1, this.lineStart = 0;
  }
  get [Symbol.toStringTag]() {
    return "Lexer";
  }
  /**
   * Advances the token stream to the next non-ignored token.
   */
  advance() {
    return this.lastToken = this.token, this.token = this.lookahead();
  }
  /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */
  lookahead() {
    let t = this.token;
    if (t.kind !== g.EOF)
      do
        if (t.next)
          t = t.next;
        else {
          const s = Ms(this, t.end);
          t.next = s, s.prev = t, t = s;
        }
      while (t.kind === g.COMMENT);
    return t;
  }
}
function Us(e) {
  return e === g.BANG || e === g.DOLLAR || e === g.AMP || e === g.PAREN_L || e === g.PAREN_R || e === g.SPREAD || e === g.COLON || e === g.EQUALS || e === g.AT || e === g.BRACKET_L || e === g.BRACKET_R || e === g.BRACE_L || e === g.PIPE || e === g.BRACE_R;
}
function Y(e) {
  return e >= 0 && e <= 55295 || e >= 57344 && e <= 1114111;
}
function xe(e, t) {
  return Et(e.charCodeAt(t)) && It(e.charCodeAt(t + 1));
}
function Et(e) {
  return e >= 55296 && e <= 56319;
}
function It(e) {
  return e >= 56320 && e <= 57343;
}
function U(e, t) {
  const s = e.source.body.codePointAt(t);
  if (s === void 0)
    return g.EOF;
  if (s >= 32 && s <= 126) {
    const a = String.fromCodePoint(s);
    return a === '"' ? `'"'` : `"${a}"`;
  }
  return "U+" + s.toString(16).toUpperCase().padStart(4, "0");
}
function T(e, t, s, a, r) {
  const o = e.line, i = 1 + s - e.lineStart;
  return new Pt(t, s, a, o, i, r);
}
function Ms(e, t) {
  const s = e.source.body, a = s.length;
  let r = t;
  for (; r < a; ) {
    const o = s.charCodeAt(r);
    switch (o) {
      // Ignored ::
      //   - UnicodeBOM
      //   - WhiteSpace
      //   - LineTerminator
      //   - Comment
      //   - Comma
      //
      // UnicodeBOM :: "Byte Order Mark (U+FEFF)"
      //
      // WhiteSpace ::
      //   - "Horizontal Tab (U+0009)"
      //   - "Space (U+0020)"
      //
      // Comma :: ,
      case 65279:
      // <BOM>
      case 9:
      // \t
      case 32:
      // <space>
      case 44:
        ++r;
        continue;
      // LineTerminator ::
      //   - "New Line (U+000A)"
      //   - "Carriage Return (U+000D)" [lookahead != "New Line (U+000A)"]
      //   - "Carriage Return (U+000D)" "New Line (U+000A)"
      case 10:
        ++r, ++e.line, e.lineStart = r;
        continue;
      case 13:
        s.charCodeAt(r + 1) === 10 ? r += 2 : ++r, ++e.line, e.lineStart = r;
        continue;
      // Comment
      case 35:
        return Gs(e, r);
      // Token ::
      //   - Punctuator
      //   - Name
      //   - IntValue
      //   - FloatValue
      //   - StringValue
      //
      // Punctuator :: one of ! $ & ( ) ... : = @ [ ] { | }
      case 33:
        return T(e, g.BANG, r, r + 1);
      case 36:
        return T(e, g.DOLLAR, r, r + 1);
      case 38:
        return T(e, g.AMP, r, r + 1);
      case 40:
        return T(e, g.PAREN_L, r, r + 1);
      case 41:
        return T(e, g.PAREN_R, r, r + 1);
      case 46:
        if (s.charCodeAt(r + 1) === 46 && s.charCodeAt(r + 2) === 46)
          return T(e, g.SPREAD, r, r + 3);
        break;
      case 58:
        return T(e, g.COLON, r, r + 1);
      case 61:
        return T(e, g.EQUALS, r, r + 1);
      case 64:
        return T(e, g.AT, r, r + 1);
      case 91:
        return T(e, g.BRACKET_L, r, r + 1);
      case 93:
        return T(e, g.BRACKET_R, r, r + 1);
      case 123:
        return T(e, g.BRACE_L, r, r + 1);
      case 124:
        return T(e, g.PIPE, r, r + 1);
      case 125:
        return T(e, g.BRACE_R, r, r + 1);
      // StringValue
      case 34:
        return s.charCodeAt(r + 1) === 34 && s.charCodeAt(r + 2) === 34 ? Zs(e, r) : Qs(e, r);
    }
    if (oe(o) || o === 45)
      return Hs(e, r, o);
    if ($t(o))
      return Ys(e, r);
    throw $(
      e.source,
      r,
      o === 39 ? `Unexpected single quote character ('), did you mean to use a double quote (")?` : Y(o) || xe(s, r) ? `Unexpected character: ${U(e, r)}.` : `Invalid character: ${U(e, r)}.`
    );
  }
  return T(e, g.EOF, a, a);
}
function Gs(e, t) {
  const s = e.source.body, a = s.length;
  let r = t + 1;
  for (; r < a; ) {
    const o = s.charCodeAt(r);
    if (o === 10 || o === 13)
      break;
    if (Y(o))
      ++r;
    else if (xe(s, r))
      r += 2;
    else
      break;
  }
  return T(
    e,
    g.COMMENT,
    t,
    r,
    s.slice(t + 1, r)
  );
}
function Hs(e, t, s) {
  const a = e.source.body;
  let r = t, o = s, i = !1;
  if (o === 45 && (o = a.charCodeAt(++r)), o === 48) {
    if (o = a.charCodeAt(++r), oe(o))
      throw $(
        e.source,
        r,
        `Invalid number, unexpected digit after 0: ${U(
          e,
          r
        )}.`
      );
  } else
    r = Ce(e, r, o), o = a.charCodeAt(r);
  if (o === 46 && (i = !0, o = a.charCodeAt(++r), r = Ce(e, r, o), o = a.charCodeAt(r)), (o === 69 || o === 101) && (i = !0, o = a.charCodeAt(++r), (o === 43 || o === 45) && (o = a.charCodeAt(++r)), r = Ce(e, r, o), o = a.charCodeAt(r)), o === 46 || $t(o))
    throw $(
      e.source,
      r,
      `Invalid number, expected digit but got: ${U(
        e,
        r
      )}.`
    );
  return T(
    e,
    i ? g.FLOAT : g.INT,
    t,
    r,
    a.slice(t, r)
  );
}
function Ce(e, t, s) {
  if (!oe(s))
    throw $(
      e.source,
      t,
      `Invalid number, expected digit but got: ${U(
        e,
        t
      )}.`
    );
  const a = e.source.body;
  let r = t + 1;
  for (; oe(a.charCodeAt(r)); )
    ++r;
  return r;
}
function Qs(e, t) {
  const s = e.source.body, a = s.length;
  let r = t + 1, o = r, i = "";
  for (; r < a; ) {
    const l = s.charCodeAt(r);
    if (l === 34)
      return i += s.slice(o, r), T(e, g.STRING, t, r + 1, i);
    if (l === 92) {
      i += s.slice(o, r);
      const c = s.charCodeAt(r + 1) === 117 ? s.charCodeAt(r + 2) === 123 ? Js(e, r) : Ws(e, r) : Xs(e, r);
      i += c.value, r += c.size, o = r;
      continue;
    }
    if (l === 10 || l === 13)
      break;
    if (Y(l))
      ++r;
    else if (xe(s, r))
      r += 2;
    else
      throw $(
        e.source,
        r,
        `Invalid character within String: ${U(
          e,
          r
        )}.`
      );
  }
  throw $(e.source, r, "Unterminated string.");
}
function Js(e, t) {
  const s = e.source.body;
  let a = 0, r = 3;
  for (; r < 12; ) {
    const o = s.charCodeAt(t + r++);
    if (o === 125) {
      if (r < 5 || !Y(a))
        break;
      return {
        value: String.fromCodePoint(a),
        size: r
      };
    }
    if (a = a << 4 | te(o), a < 0)
      break;
  }
  throw $(
    e.source,
    t,
    `Invalid Unicode escape sequence: "${s.slice(
      t,
      t + r
    )}".`
  );
}
function Ws(e, t) {
  const s = e.source.body, a = pt(s, t + 2);
  if (Y(a))
    return {
      value: String.fromCodePoint(a),
      size: 6
    };
  if (Et(a) && s.charCodeAt(t + 6) === 92 && s.charCodeAt(t + 7) === 117) {
    const r = pt(s, t + 8);
    if (It(r))
      return {
        value: String.fromCodePoint(a, r),
        size: 12
      };
  }
  throw $(
    e.source,
    t,
    `Invalid Unicode escape sequence: "${s.slice(t, t + 6)}".`
  );
}
function pt(e, t) {
  return te(e.charCodeAt(t)) << 12 | te(e.charCodeAt(t + 1)) << 8 | te(e.charCodeAt(t + 2)) << 4 | te(e.charCodeAt(t + 3));
}
function te(e) {
  return e >= 48 && e <= 57 ? e - 48 : e >= 65 && e <= 70 ? e - 55 : e >= 97 && e <= 102 ? e - 87 : -1;
}
function Xs(e, t) {
  const s = e.source.body;
  switch (s.charCodeAt(t + 1)) {
    case 34:
      return {
        value: '"',
        size: 2
      };
    case 92:
      return {
        value: "\\",
        size: 2
      };
    case 47:
      return {
        value: "/",
        size: 2
      };
    case 98:
      return {
        value: "\b",
        size: 2
      };
    case 102:
      return {
        value: "\f",
        size: 2
      };
    case 110:
      return {
        value: `
`,
        size: 2
      };
    case 114:
      return {
        value: "\r",
        size: 2
      };
    case 116:
      return {
        value: "	",
        size: 2
      };
  }
  throw $(
    e.source,
    t,
    `Invalid character escape sequence: "${s.slice(
      t,
      t + 2
    )}".`
  );
}
function Zs(e, t) {
  const s = e.source.body, a = s.length;
  let r = e.lineStart, o = t + 3, i = o, l = "";
  const c = [];
  for (; o < a; ) {
    const u = s.charCodeAt(o);
    if (u === 34 && s.charCodeAt(o + 1) === 34 && s.charCodeAt(o + 2) === 34) {
      l += s.slice(i, o), c.push(l);
      const d = T(
        e,
        g.BLOCK_STRING,
        t,
        o + 3,
        // Return a string of the lines joined with U+000A.
        qs(c).join(`
`)
      );
      return e.line += c.length - 1, e.lineStart = r, d;
    }
    if (u === 92 && s.charCodeAt(o + 1) === 34 && s.charCodeAt(o + 2) === 34 && s.charCodeAt(o + 3) === 34) {
      l += s.slice(i, o), i = o + 1, o += 4;
      continue;
    }
    if (u === 10 || u === 13) {
      l += s.slice(i, o), c.push(l), u === 13 && s.charCodeAt(o + 1) === 10 ? o += 2 : ++o, l = "", i = o, r = o;
      continue;
    }
    if (Y(u))
      ++o;
    else if (xe(s, o))
      o += 2;
    else
      throw $(
        e.source,
        o,
        `Invalid character within String: ${U(
          e,
          o
        )}.`
      );
  }
  throw $(e.source, o, "Unterminated string.");
}
function Ys(e, t) {
  const s = e.source.body, a = s.length;
  let r = t + 1;
  for (; r < a; ) {
    const o = s.charCodeAt(r);
    if (Fs(o))
      ++r;
    else
      break;
  }
  return T(
    e,
    g.NAME,
    t,
    r,
    s.slice(t, r)
  );
}
const Ks = 10, kt = 2;
function Dt(e) {
  return ge(e, []);
}
function ge(e, t) {
  switch (typeof e) {
    case "string":
      return JSON.stringify(e);
    case "function":
      return e.name ? `[function ${e.name}]` : "[function]";
    case "object":
      return er(e, t);
    default:
      return String(e);
  }
}
function er(e, t) {
  if (e === null)
    return "null";
  if (t.includes(e))
    return "[Circular]";
  const s = [...t, e];
  if (tr(e)) {
    const a = e.toJSON();
    if (a !== e)
      return typeof a == "string" ? a : ge(a, s);
  } else if (Array.isArray(e))
    return sr(e, s);
  return nr(e, s);
}
function tr(e) {
  return typeof e.toJSON == "function";
}
function nr(e, t) {
  const s = Object.entries(e);
  return s.length === 0 ? "{}" : t.length > kt ? "[" + rr(e) + "]" : "{ " + s.map(
    ([r, o]) => r + ": " + ge(o, t)
  ).join(", ") + " }";
}
function sr(e, t) {
  if (e.length === 0)
    return "[]";
  if (t.length > kt)
    return "[Array]";
  const s = Math.min(Ks, e.length), a = e.length - s, r = [];
  for (let o = 0; o < s; ++o)
    r.push(ge(e[o], t));
  return a === 1 ? r.push("... 1 more item") : a > 1 && r.push(`... ${a} more items`), "[" + r.join(", ") + "]";
}
function rr(e) {
  const t = Object.prototype.toString.call(e).replace(/^\[object /, "").replace(/]$/, "");
  if (t === "Object" && typeof e.constructor == "function") {
    const s = e.constructor.name;
    if (typeof s == "string" && s !== "")
      return s;
  }
  return t;
}
const ar = globalThis.process && // eslint-disable-next-line no-undef
process.env.NODE_ENV === "production", or = (
  /* c8 ignore next 6 */
  // FIXME: https://github.com/graphql/graphql-js/issues/2317
  ar ? function(t, s) {
    return t instanceof s;
  } : function(t, s) {
    if (t instanceof s)
      return !0;
    if (typeof t == "object" && t !== null) {
      var a;
      const r = s.prototype[Symbol.toStringTag], o = (
        // We still need to support constructor's name to detect conflicts with older versions of this library.
        Symbol.toStringTag in t ? t[Symbol.toStringTag] : (a = t.constructor) === null || a === void 0 ? void 0 : a.name
      );
      if (r === o) {
        const i = Dt(t);
        throw new Error(`Cannot use ${r} "${i}" from another module or realm.

Ensure that there is only one instance of "graphql" in the node_modules
directory. If different versions of "graphql" are the dependencies of other
relied on modules, use "resolutions" to ensure only one version is installed.

https://yarnpkg.com/en/docs/selective-version-resolutions

Duplicate "graphql" modules cannot be used at the same time since different
versions may have different capabilities and behavior. The data from one
version used in the function from another could produce confusing and
spurious results.`);
      }
    }
    return !1;
  }
);
class zt {
  constructor(t, s = "GraphQL request", a = {
    line: 1,
    column: 1
  }) {
    typeof t == "string" || we(!1, `Body must be a string. Received: ${Dt(t)}.`), this.body = t, this.name = s, this.locationOffset = a, this.locationOffset.line > 0 || we(
      !1,
      "line in locationOffset is 1-indexed and must be positive."
    ), this.locationOffset.column > 0 || we(
      !1,
      "column in locationOffset is 1-indexed and must be positive."
    );
  }
  get [Symbol.toStringTag]() {
    return "Source";
  }
}
function ir(e) {
  return or(e, zt);
}
function cr(e) {
  const t = ir(e) ? e : new zt(e), s = t.body, a = new _s(t);
  let r = "", o = !1;
  for (; a.advance().kind !== g.EOF; ) {
    const i = a.token, l = i.kind, c = !Us(i.kind);
    o && (c || i.kind === g.SPREAD) && (r += " ");
    const u = s.slice(i.start, i.end);
    l === g.BLOCK_STRING ? r += Bs(i.value, {
      minimize: !0
    }) : r += u, o = c;
  }
  return r;
}
const Ft = wt(
  void 0
), Ja = ({
  children: e,
  client: t
}) => /* @__PURE__ */ n.jsx(Ft.Provider, { value: t, children: e }), qt = (e, t, ...[s]) => ({
  queryFn: () => e.fetch(t, s),
  queryKey: [cr(t.toString()), s]
}), lr = (e, ...[t]) => {
  const s = ts(Ft);
  if (s === void 0)
    throw new Error("useGraphQL must be used within a GraphQLProvider");
  return qt(s, e, ...t === void 0 ? [] : [t]);
};
class H extends String {
  __apiType;
  value;
  __meta__;
  constructor(t, s) {
    super(t), this.value = t, this.__meta__ = s;
  }
  toString() {
    return this.value;
  }
}
const dr = new H(
  `
    fragment OperationsFragment on OperationItem {
  slug
  summary
  method
  description
  operationId
  contentTypes
  path
  deprecated
  extensions
  parameters {
    name
    in
    description
    required
    schema
    style
    explode
    examples {
      name
      description
      externalValue
      value
      summary
    }
  }
  requestBody {
    content {
      mediaType
      encoding {
        name
      }
      examples {
        name
        description
        externalValue
        value
        summary
      }
      schema
    }
    description
    required
  }
  responses {
    statusCode
    links
    description
    content {
      examples {
        name
        description
        externalValue
        value
        summary
      }
      mediaType
      encoding {
        name
      }
      schema
    }
  }
}
    `,
  { fragmentName: "OperationsFragment" }
), ur = new H(`
    query ServersQuery($input: JSON!, $type: SchemaType!) {
  schema(input: $input, type: $type) {
    url
    servers {
      url
    }
  }
}
    `), mr = new H(`
    query SchemaWarmup($input: JSON!, $type: SchemaType!) {
  schema(input: $input, type: $type) {
    openapi
  }
}
    `), pr = new H(`
    query OperationsForTag($input: JSON!, $type: SchemaType!, $tag: String, $untagged: Boolean) {
  schema(input: $input, type: $type) {
    servers {
      url
    }
    description
    summary
    title
    url
    version
    tag(slug: $tag, untagged: $untagged) {
      name
      description
      operations {
        slug
        ...OperationsFragment
      }
      next {
        name
        slug
      }
      prev {
        name
        slug
      }
    }
  }
}
    fragment OperationsFragment on OperationItem {
  slug
  summary
  method
  description
  operationId
  contentTypes
  path
  deprecated
  extensions
  parameters {
    name
    in
    description
    required
    schema
    style
    explode
    examples {
      name
      description
      externalValue
      value
      summary
    }
  }
  requestBody {
    content {
      mediaType
      encoding {
        name
      }
      examples {
        name
        description
        externalValue
        value
        summary
      }
      schema
    }
    description
    required
  }
  responses {
    statusCode
    links
    description
    content {
      examples {
        name
        description
        externalValue
        value
        summary
      }
      mediaType
      encoding {
        name
      }
      schema
    }
  }
}`), hr = new H(`
    query GetSchemas($input: JSON!, $type: SchemaType!) {
  schema(input: $input, type: $type) {
    title
    description
    summary
    components {
      schemas {
        name
        schema
        extensions
      }
    }
  }
}
    `), fr = new H(`
    query getServerQuery($input: JSON!, $type: SchemaType!) {
  schema(input: $input, type: $type) {
    url
    servers {
      url
    }
  }
}
    `), xr = new H(`
    query GetNavigationOperations($input: JSON!, $type: SchemaType!) {
  schema(input: $input, type: $type) {
    tags {
      slug
      name
      extensions
      operations {
        summary
        slug
        method
        operationId
        path
      }
    }
    components {
      schemas {
        __typename
      }
    }
  }
}
    `), gr = {
  "\n  query ServersQuery($input: JSON!, $type: SchemaType!) {\n    schema(input: $input, type: $type) {\n      url\n      servers {\n        url\n      }\n    }\n  }\n": ur,
  "\n  fragment OperationsFragment on OperationItem {\n    slug\n    summary\n    method\n    description\n    operationId\n    contentTypes\n    path\n    deprecated\n    extensions\n    parameters {\n      name\n      in\n      description\n      required\n      schema\n      style\n      explode\n      examples {\n        name\n        description\n        externalValue\n        value\n        summary\n      }\n    }\n    requestBody {\n      content {\n        mediaType\n        encoding {\n          name\n        }\n        examples {\n          name\n          description\n          externalValue\n          value\n          summary\n        }\n        schema\n      }\n      description\n      required\n    }\n    responses {\n      statusCode\n      links\n      description\n      content {\n        examples {\n          name\n          description\n          externalValue\n          value\n          summary\n        }\n        mediaType\n        encoding {\n          name\n        }\n        schema\n      }\n    }\n  }\n": dr,
  "\n  query SchemaWarmup($input: JSON!, $type: SchemaType!) {\n    schema(input: $input, type: $type) {\n      openapi\n    }\n  }\n": mr,
  "\n  query OperationsForTag(\n    $input: JSON!\n    $type: SchemaType!\n    $tag: String\n    $untagged: Boolean\n  ) {\n    schema(input: $input, type: $type) {\n      servers {\n        url\n      }\n      description\n      summary\n      title\n      url\n      version\n      tag(slug: $tag, untagged: $untagged) {\n        name\n        description\n        operations {\n          slug\n          ...OperationsFragment\n        }\n        next {\n          name\n          slug\n        }\n        prev {\n          name\n          slug\n        }\n      }\n    }\n  }\n": pr,
  "\n  query GetSchemas($input: JSON!, $type: SchemaType!) {\n    schema(input: $input, type: $type) {\n      title\n      description\n      summary\n      components {\n        schemas {\n          name\n          schema\n          extensions\n        }\n      }\n    }\n  }\n": hr,
  "\n  query getServerQuery($input: JSON!, $type: SchemaType!) {\n    schema(input: $input, type: $type) {\n      url\n      servers {\n        url\n      }\n    }\n  }\n": fr,
  "\n  query GetNavigationOperations($input: JSON!, $type: SchemaType!) {\n    schema(input: $input, type: $type) {\n      tags {\n        slug\n        name\n        extensions\n        operations {\n          summary\n          slug\n          method\n          operationId\n          path\n        }\n      }\n      components {\n        schemas {\n          __typename\n        }\n      }\n    }\n  }\n": xr
};
function yr(e) {
  return gr[e] ?? {};
}
const q = Fe.Root, Vt = Fe.CollapsibleTrigger, V = Fe.CollapsibleContent, Bt = S.Root, _t = S.Value, Ve = w.forwardRef(({ className: e, children: t, ...s }, a) => /* @__PURE__ */ n.jsxs(
  S.Trigger,
  {
    ref: a,
    className: v(
      "flex h-10 w-full items-center justify-between rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus:outline-hidden focus:ring-1 focus:ring-ring focus:ring-offset-1 disabled:cursor-not-allowed disabled:opacity-50",
      e
    ),
    ...s,
    children: [
      /* @__PURE__ */ n.jsx("span", { className: "truncate", children: t }),
      /* @__PURE__ */ n.jsx(S.Icon, { asChild: !0, children: /* @__PURE__ */ n.jsx(yt, { className: "shrink-0 h-4 w-4 opacity-50" }) })
    ]
  }
));
Ve.displayName = S.Trigger.displayName;
const Ut = w.forwardRef(({ className: e, ...t }, s) => /* @__PURE__ */ n.jsx(
  S.ScrollUpButton,
  {
    ref: s,
    className: v(
      "flex cursor-default items-center justify-center py-1",
      e
    ),
    ...t,
    children: /* @__PURE__ */ n.jsx(wn, { className: "h-4 w-4" })
  }
));
Ut.displayName = S.ScrollUpButton.displayName;
const Mt = w.forwardRef(({ className: e, ...t }, s) => /* @__PURE__ */ n.jsx(
  S.ScrollDownButton,
  {
    ref: s,
    className: v(
      "flex cursor-default items-center justify-center py-1",
      e
    ),
    ...t,
    children: /* @__PURE__ */ n.jsx(yt, { className: "h-4 w-4" })
  }
));
Mt.displayName = S.ScrollDownButton.displayName;
const Be = w.forwardRef(({ className: e, children: t, position: s = "popper", ...a }, r) => /* @__PURE__ */ n.jsx(S.Portal, { children: /* @__PURE__ */ n.jsxs(
  S.Content,
  {
    ref: r,
    className: v(
      "relative z-50 max-h-96 min-w-[8rem] overflow-hidden rounded-md border bg-popover text-popover-foreground shadow-md data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      s === "popper" && "data-[side=bottom]:translate-y-1 data-[side=left]:-translate-x-1 data-[side=right]:translate-x-1 data-[side=top]:-translate-y-1",
      e
    ),
    position: s,
    ...a,
    children: [
      /* @__PURE__ */ n.jsx(Ut, {}),
      /* @__PURE__ */ n.jsx(
        S.Viewport,
        {
          className: v(
            s === "popper" && "h-[var(--radix-select-trigger-height)] w-full min-w-[var(--radix-select-trigger-width)]",
            "divide-y"
          ),
          children: t
        }
      ),
      /* @__PURE__ */ n.jsx(Mt, {})
    ]
  }
) }));
Be.displayName = S.Content.displayName;
const vr = w.forwardRef(({ className: e, ...t }, s) => /* @__PURE__ */ n.jsx(
  S.Label,
  {
    ref: s,
    className: v("py-1.5 pl-8 pr-2 text-sm font-semibold", e),
    ...t
  }
));
vr.displayName = S.Label.displayName;
const ne = w.forwardRef(({ className: e, children: t, ...s }, a) => /* @__PURE__ */ n.jsxs(
  S.Item,
  {
    ref: a,
    className: v(
      "relative flex w-full cursor-default select-none items-center py-1.5 pl-8 pr-2 text-sm outline-hidden focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      e
    ),
    ...s,
    children: [
      /* @__PURE__ */ n.jsx("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ n.jsx(S.ItemIndicator, { children: /* @__PURE__ */ n.jsx(vt, { className: "h-4 w-4" }) }) }),
      /* @__PURE__ */ n.jsx(S.ItemText, { children: t })
    ]
  }
));
ne.displayName = S.Item.displayName;
const br = w.forwardRef(({ className: e, ...t }, s) => /* @__PURE__ */ n.jsx(
  S.Separator,
  {
    ref: s,
    className: v("-mx-1 my-1 h-px bg-muted", e),
    ...t
  }
));
br.displayName = S.Separator.displayName;
function jr() {
  const t = navigator.userAgent.toLowerCase();
  if (t.indexOf("win") !== -1)
    return "windows";
  if (t.indexOf("mac") !== -1)
    return "apple";
  if (t.indexOf("linux") !== -1)
    return "linux";
  if (t.indexOf("x11") !== -1)
    return "unix";
}
function Nr() {
  return jr() === "apple";
}
const wr = {
  other: {
    alt: "Alt",
    meta: "Ctrl",
    ctrl: "Ctrl",
    shift: "⇧",
    option: "Alt"
  },
  apple: {
    alt: "⌥",
    meta: "⌘",
    ctrl: "Ctrl",
    shift: "⇧",
    option: "⌥"
  }
}, Cr = (e, t) => {
  const s = e.toLowerCase().split("+"), a = s.includes("meta"), r = s.includes("shift"), o = s.includes("option") || s.includes("alt"), i = s.includes("ctrl"), l = e.split("+").pop(), c = L(t);
  return z(() => {
    c.current = t;
  }, [t]), z(() => {
    const u = (d) => {
      (d.code === `Key${l?.toUpperCase()}` || d.code.toLowerCase() === l?.toLowerCase()) && d.metaKey === a && d.shiftKey === r && d.altKey === o && d.ctrlKey === i && (d.preventDefault(), c.current());
    };
    return window.addEventListener("keydown", u), () => {
      window.removeEventListener("keydown", u);
    };
  }, [l, a, r, o, i]), {
    trigger: () => c.current(),
    label: s.map(
      (u) => u === "meta" || u === "ctrl" || u === "alt" || u === "shift" || u === "option" ? wr[Nr() ? "apple" : "other"][u] : u
    )
  };
}, Sr = $e()(
  Ee(
    (e) => ({
      selectedServer: void 0,
      setSelectedServer: (t) => e({ selectedServer: t })
    }),
    { name: "zudoku-selected-server" }
  )
), Tr = (e) => {
  const { selectedServer: t, setSelectedServer: s } = Sr();
  return { selectedServer: Ct(
    () => t && e.some((r) => r.url === t) ? t : e.at(0)?.url ?? "",
    [t, e]
  ), setSelectedServer: s };
}, Gt = w.forwardRef(
  ({ className: e, ...t }, s) => /* @__PURE__ */ n.jsx(
    "textarea",
    {
      className: v(
        "flex min-h-[80px] w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background placeholder:text-muted-foreground focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        e
      ),
      ref: s,
      ...t
    }
  )
);
Gt.displayName = "Textarea";
const M = ({
  children: e,
  className: t
}) => /* @__PURE__ */ n.jsxs(
  "div",
  {
    className: v(
      "grid grid-cols-[max-content_1fr_min-content_max-content] items-center gap-4 group bg-muted w-full h-10 ps-4 pe-2 border-b",
      t
    ),
    children: [
      e,
      /* @__PURE__ */ n.jsx(
        Vt,
        {
          className: v(
            "flex items-center gap-4 group bg-muted w-full p-2 hover:bg-accent hover:brightness-95 rounded-md",
            t
          ),
          children: /* @__PURE__ */ n.jsx(
            Cn,
            {
              className: "group-data-[state=open]:rotate-180 transition-transform flex-shrink-0",
              size: 16
            }
          )
        }
      )
    ]
  }
), G = ({
  children: e,
  className: t
}) => /* @__PURE__ */ n.jsx("span", { className: v("font-semibold w-full text-start", t), children: e }), Ar = C.Root, Or = C.Trigger, Rr = C.Group, Pr = w.forwardRef(({ className: e, inset: t, children: s, ...a }, r) => /* @__PURE__ */ n.jsxs(
  C.SubTrigger,
  {
    ref: r,
    className: v(
      "flex cursor-default select-none items-center rounded-xs px-2 py-1.5 text-sm outline-hidden focus:bg-accent data-[state=open]:bg-accent",
      t && "pl-8",
      e
    ),
    ...a,
    children: [
      s,
      /* @__PURE__ */ n.jsx(Sn, { className: "ml-auto h-4 w-4" })
    ]
  }
));
Pr.displayName = C.SubTrigger.displayName;
const Lr = w.forwardRef(({ className: e, ...t }, s) => /* @__PURE__ */ n.jsx(
  C.SubContent,
  {
    ref: s,
    className: v(
      "z-50 min-w-[8rem] overflow-hidden rounded-md border bg-popover p-1 text-popover-foreground shadow-lg data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      e
    ),
    ...t
  }
));
Lr.displayName = C.SubContent.displayName;
const Ht = w.forwardRef(({ className: e, sideOffset: t = 4, ...s }, a) => /* @__PURE__ */ n.jsx(C.Portal, { children: /* @__PURE__ */ n.jsx(
  C.Content,
  {
    ref: a,
    sideOffset: t,
    className: v(
      "z-50 min-w-[8rem] overflow-hidden rounded-md border bg-popover p-1 text-popover-foreground shadow-md",
      "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      e
    ),
    ...s
  }
) }));
Ht.displayName = C.Content.displayName;
const Qt = w.forwardRef(({ className: e, inset: t, ...s }, a) => /* @__PURE__ */ n.jsx(
  C.Item,
  {
    ref: a,
    className: v(
      "relative flex cursor-default select-none items-center rounded-xs px-2 py-1.5 text-sm outline-hidden transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      t && "pl-8",
      e
    ),
    ...s
  }
));
Qt.displayName = C.Item.displayName;
const $r = w.forwardRef(({ className: e, children: t, checked: s, ...a }, r) => /* @__PURE__ */ n.jsxs(
  C.CheckboxItem,
  {
    ref: r,
    className: v(
      "relative flex cursor-default select-none items-center rounded-xs py-1.5 pl-8 pr-2 text-sm outline-hidden transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      e
    ),
    checked: s,
    ...a,
    children: [
      /* @__PURE__ */ n.jsx("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ n.jsx(C.ItemIndicator, { children: /* @__PURE__ */ n.jsx(bt, { className: "h-4 w-4" }) }) }),
      t
    ]
  }
));
$r.displayName = C.CheckboxItem.displayName;
const Er = w.forwardRef(({ className: e, children: t, ...s }, a) => /* @__PURE__ */ n.jsxs(
  C.RadioItem,
  {
    ref: a,
    className: v(
      "relative flex cursor-default select-none items-center rounded-xs py-1.5 pl-8 pr-2 text-sm outline-hidden transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      e
    ),
    ...s,
    children: [
      /* @__PURE__ */ n.jsx("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ n.jsx(C.ItemIndicator, { children: /* @__PURE__ */ n.jsx(Tn, { className: "h-4 w-4 fill-current" }) }) }),
      t
    ]
  }
));
Er.displayName = C.RadioItem.displayName;
const Jt = w.forwardRef(({ className: e, inset: t, ...s }, a) => /* @__PURE__ */ n.jsx(
  C.Label,
  {
    ref: a,
    className: v(
      "px-2 py-1.5 text-sm font-semibold",
      t && "pl-8",
      e
    ),
    ...s
  }
));
Jt.displayName = C.Label.displayName;
const Wt = w.forwardRef(({ className: e, ...t }, s) => /* @__PURE__ */ n.jsx(
  C.Separator,
  {
    ref: s,
    className: v("-mx-1 my-1 h-px bg-muted", e),
    ...t
  }
));
Wt.displayName = C.Separator.displayName;
const Ir = ({
  examples: e,
  onSelect: t
}) => /* @__PURE__ */ n.jsxs(Ar, { children: [
  /* @__PURE__ */ n.jsx(Or, { asChild: !0, children: /* @__PURE__ */ n.jsxs(
    E,
    {
      variant: "ghost",
      size: "sm",
      className: "hover:bg-accent hover:brightness-95",
      children: [
        "Use Example ",
        /* @__PURE__ */ n.jsx(fe, { size: 16, className: "ml-2" })
      ]
    }
  ) }),
  /* @__PURE__ */ n.jsx(Ht, { className: "max-w-72", children: e.map((s) => /* @__PURE__ */ n.jsxs("div", { children: [
    /* @__PURE__ */ n.jsx(Jt, { children: s.mediaType }),
    /* @__PURE__ */ n.jsx(Wt, {}),
    /* @__PURE__ */ n.jsx(Rr, { children: s.examples?.map((a) => /* @__PURE__ */ n.jsx(
      Qt,
      {
        onSelect: () => t(a, s.mediaType),
        children: /* @__PURE__ */ n.jsx(
          "span",
          {
            className: "line-clamp-1",
            title: a.summary ?? a.name,
            children: a.summary ?? a.name
          }
        )
      },
      a.name
    )) })
  ] }, s.mediaType)) })
] }), kr = ({ content: e }) => {
  const { register: t, setValue: s, watch: a } = ie(), r = (e ?? []).flatMap((i) => i.examples), o = a("headers");
  return /* @__PURE__ */ n.jsxs(q, { defaultOpen: !0, children: [
    /* @__PURE__ */ n.jsxs(M, { children: [
      /* @__PURE__ */ n.jsx(An, { size: 16 }),
      /* @__PURE__ */ n.jsx(G, { children: "Body" }),
      e && r.length > 0 ? /* @__PURE__ */ n.jsx(
        Ir,
        {
          examples: e,
          onSelect: (i, l) => {
            s("body", JSON.stringify(i.value, null, 2)), s("headers", [
              ...o.filter((c) => c.name !== "Content-Type"),
              {
                name: "Content-Type",
                value: l,
                active: !0
              }
            ]);
          }
        }
      ) : /* @__PURE__ */ n.jsx("div", {})
    ] }),
    /* @__PURE__ */ n.jsx(V, { className: "flex flex-col gap-2 ", children: /* @__PURE__ */ n.jsx(
      Gt,
      {
        ...t("body"),
        className: v(
          "w-full p-2 h-64 font-mono md:text-xs border-none rounded-none focus-visible:ring-0"
        ),
        placeholder: "Your body here..."
      }
    ) })
  ] });
}, ht = (e, t, s) => {
  const a = t.replace(/(:\w+|\{\w+})/g, (o) => {
    const i = o.replace(/[:{}]/g, "");
    return s.pathParams.find((c) => c.name === i)?.value ?? o;
  }), r = new URL(
    a.replace(/^\//, ""),
    e.endsWith("/") ? e : `${e}/`
  );
  return s.queryParams.filter((o) => o.active).forEach((o) => {
    r.searchParams.set(o.name, o.value);
  }), r;
};
function Dr(e) {
  return /^(application\/octet-stream|image\/|audio\/|video\/|font\/|application\/pdf|application\/zip|application\/x-protobuf|application\/x-binary)/i.test(
    e
  );
}
const zr = (e, t) => {
  const s = e.find(
    ([a]) => a.toLowerCase() === "content-disposition"
  )?.[1];
  if (s) {
    const a = s.match(
      /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
    );
    if (a?.[1])
      return a[1].replace(/['"]/g, "");
  }
  try {
    const r = new URL(t).pathname.split("/").pop() || "download";
    return r.includes(".") ? r : "download";
  } catch {
    return "download";
  }
}, ye = w.forwardRef(({ className: e, ...t }, s) => /* @__PURE__ */ n.jsx(
  Re.Root,
  {
    ref: s,
    className: v(
      "peer h-4 w-4 shrink-0 rounded-[min(6px,var(--radius)-4px)] ring-offset-background focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:text-primary",
      "border border-primary data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground data-[state=checked]:border-primary",
      e
    ),
    ...t,
    children: /* @__PURE__ */ n.jsx(
      Re.Indicator,
      {
        className: v("flex items-center justify-center text-current"),
        children: /* @__PURE__ */ n.jsx(vt, { className: "h-4 w-4" })
      }
    )
  }
));
ye.displayName = Re.Root.displayName;
const Fr = ue.Root, Xt = w.forwardRef(({ className: e, align: t = "center", sideOffset: s = 4, ...a }, r) => /* @__PURE__ */ n.jsx(ue.Portal, { children: /* @__PURE__ */ n.jsx(
  ue.Content,
  {
    ref: r,
    align: t,
    sideOffset: s,
    className: v(
      "z-50 w-72 rounded-md border bg-popover p-4 text-popover-foreground shadow-md outline-hidden data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      e
    ),
    ...a
  }
) }));
Xt.displayName = ue.Content.displayName;
const qr = ({
  value: e,
  options: t,
  onChange: s,
  className: a,
  placeholder: r = "Value",
  onEnterPress: o,
  ref: i
}) => {
  const [l, c] = k(!1), [u, d] = k(!1), h = vs((m) => m.filtered.count), f = L(null);
  return /* @__PURE__ */ n.jsxs(Fr, { open: l, children: [
    /* @__PURE__ */ n.jsx(ys, { children: /* @__PURE__ */ n.jsx(
      js,
      {
        autoComplete: "off",
        ref: (m) => {
          f.current = m, typeof i == "function" ? i(m) : i && (i.current = m);
        },
        value: e,
        placeholder: r,
        className: v("h-9 bg-transparent", a),
        onFocus: () => c(!0),
        onBlur: () => {
          u || c(!1);
        },
        onKeyDown: (m) => {
          m.key === "Enter" && (c(!1), f.current?.blur(), o?.(m));
        },
        onValueChange: (m) => s(m)
      }
    ) }),
    /* @__PURE__ */ n.jsx(
      Xt,
      {
        onMouseEnter: () => d(!0),
        onMouseLeave: () => d(!1),
        onOpenAutoFocus: (m) => m.preventDefault(),
        className: v("p-0 w-(--radix-popover-trigger-width)", {
          "border-0": h === 0
        }),
        align: "start",
        side: "bottom",
        onWheel: (m) => {
          m.stopPropagation();
        },
        onTouchMove: (m) => {
          m.stopPropagation();
        },
        children: /* @__PURE__ */ n.jsx(Ns, { className: "max-h-[140px]", children: t.map((m) => /* @__PURE__ */ n.jsx(
          ws,
          {
            value: m,
            onSelect: (x) => {
              s(x), c(!1);
            },
            className: "cursor-pointer",
            children: m
          },
          m
        )) })
      }
    )
  ] });
}, pe = ({ shouldFilter: e, ...t }) => /* @__PURE__ */ n.jsx(bs, { className: "bg-transparent", shouldFilter: e, children: /* @__PURE__ */ n.jsx(qr, { ...t }) }), ce = (e, t) => {
  const s = w.forwardRef(({ className: a, asChild: r, ...o }, i) => {
    const l = r ? Cs : e;
    return w.createElement(l, {
      ...o,
      ref: i,
      className: typeof t == "function" ? t({ className: a }) : v(t, a)
    });
  });
  return s.displayName = `VariantComponent(${e})`, s;
}, _e = ce(
  "div",
  "grid grid-cols-[min-content_2fr_3fr] items-center gap-x-5"
), he = ce(
  "div",
  "group h-9 hover:bg-accent/75 ps-4 pe-2 grid col-span-full grid-cols-subgrid items-center border-b"
), Vr = Object.freeze([
  "Accept",
  "Accept-Encoding",
  "Accept-Language",
  "Authorization",
  "Cache-Control",
  "Connection",
  "Content-Disposition",
  "Content-Encoding",
  "Content-Language",
  "Content-Length",
  "Content-Range",
  "Content-Security-Policy",
  "Content-Type",
  "Cookie",
  "Date",
  "ETag",
  "Expires",
  "Host",
  "If-Modified-Since",
  "Location",
  "Origin",
  "Pragma",
  "Referer",
  "Set-Cookie",
  "User-Agent",
  "X-Requested-With"
]), Br = ({
  control: e,
  schemaHeaders: t,
  lockedHeaders: s
}) => {
  const { fields: a, append: r, remove: o } = ze({
    control: e,
    name: "headers"
  }), { setValue: i, watch: l, formState: c } = ie(), u = L([]), d = L([]), h = l("headers"), f = St(
    (j) => {
      j?.stopPropagation(), r({ name: "", value: "", active: !1 }, { shouldFocus: !0 });
    },
    [r]
  );
  z(() => {
    h.length === 0 && f();
  }, [h, f]);
  const m = (j) => {
    u.current[j]?.focus();
  }, x = (j) => {
    f(), requestAnimationFrame(() => d.current[j + 1]?.focus());
  }, y = t.filter((j) => !h.some((N) => N.name === j.name)).map(({ name: j }) => j), b = a.flatMap((j, N) => !s?.map((O) => O.toLowerCase()).includes(j.name.toLowerCase()) ? [] : [N]), R = s?.map((j) => ({
    name: j,
    id: `locked-${j}`,
    value: "••••••••••",
    active: !0,
    locked: !0
  })) ?? [];
  return /* @__PURE__ */ n.jsxs(q, { defaultOpen: !0, children: [
    /* @__PURE__ */ n.jsxs(M, { children: [
      /* @__PURE__ */ n.jsx(On, { size: 16 }),
      /* @__PURE__ */ n.jsx(G, { children: "Headers" }),
      /* @__PURE__ */ n.jsxs(
        re,
        {
          onClick: f,
          type: "button",
          size: "sm",
          variant: "ghost",
          className: "hover:bg-accent hover:brightness-95 flex gap-2",
          children: [
            "Add header ",
            /* @__PURE__ */ n.jsx(fe, { size: 16 })
          ]
        }
      )
    ] }),
    /* @__PURE__ */ n.jsx(V, { className: "CollapsibleContent", children: /* @__PURE__ */ n.jsx("div", { className: "flex flex-col gap-2", children: /* @__PURE__ */ n.jsx("div", { className: "overflow-hidden", children: /* @__PURE__ */ n.jsxs(_e, { children: [
      R.map((j) => /* @__PURE__ */ n.jsxs(it, { children: [
        /* @__PURE__ */ n.jsx(ct, { asChild: !0, children: /* @__PURE__ */ n.jsxs(
          he,
          {
            className: "opacity-50 cursor-not-allowed font-mono text-xs min-h-10",
            children: [
              /* @__PURE__ */ n.jsx(Rn, { size: 16 }),
              /* @__PURE__ */ n.jsx(
                me,
                {
                  value: j.name,
                  disabled: !0,
                  className: "w-full border-0 p-0 m-0 shadow-none text-xs focus-visible:ring-0 font-mono"
                }
              ),
              /* @__PURE__ */ n.jsx("div", { children: j.value })
            ]
          },
          j.id
        ) }),
        /* @__PURE__ */ n.jsx(
          lt,
          {
            alignOffset: 10,
            side: "bottom",
            align: "start",
            children: /* @__PURE__ */ n.jsx("p", { children: "This header is set by the selected authentication." })
          }
        )
      ] }, j.id)),
      a.map((j, N) => {
        const Q = t.find(
          (O) => O.name === h.at(N)?.name
        );
        return /* @__PURE__ */ n.jsxs(
          he,
          {
            className: v(
              b.includes(N) && "text-amber-600",
              b.includes(N) && !c.dirtyFields.headers?.[N]?.value && "hidden"
            ),
            children: [
              /* @__PURE__ */ n.jsx(
                F,
                {
                  control: e,
                  name: `headers.${N}.active`,
                  render: ({ field: O }) => /* @__PURE__ */ n.jsxs(n.Fragment, { children: [
                    /* @__PURE__ */ n.jsx(
                      ye,
                      {
                        id: `headers.${N}.active`,
                        className: v(
                          b.includes(N) && "hidden"
                        ),
                        checked: O.value,
                        onCheckedChange: (D) => {
                          O.onChange(D);
                        }
                      }
                    ),
                    /* @__PURE__ */ n.jsxs(it, { children: [
                      /* @__PURE__ */ n.jsx(ct, { asChild: !0, children: /* @__PURE__ */ n.jsx(
                        Pn,
                        {
                          className: v(
                            "text-amber-600",
                            !b.includes(N) && "hidden"
                          ),
                          size: 16
                        }
                      ) }),
                      /* @__PURE__ */ n.jsx(
                        lt,
                        {
                          alignOffset: 10,
                          side: "bottom",
                          align: "start",
                          children: /* @__PURE__ */ n.jsx("p", { children: "This header will be overwritten by the selected authentication." })
                        }
                      )
                    ] })
                  ] })
                }
              ),
              /* @__PURE__ */ n.jsx(
                F,
                {
                  control: e,
                  name: `headers.${N}.name`,
                  render: ({ field: O }) => /* @__PURE__ */ n.jsx(
                    pe,
                    {
                      ...O,
                      placeholder: "Name",
                      className: "border-0 p-0 m-0 shadow-none focus-visible:ring-0 bg-transparent hover:bg-transparent text-xs font-mono",
                      options: [...y, ...Vr],
                      onEnterPress: () => m(N),
                      onChange: (D) => {
                        O.onChange(D), i(`headers.${N}.active`, !0);
                      },
                      ref: (D) => {
                        d.current[N] = D;
                      }
                    }
                  )
                }
              ),
              /* @__PURE__ */ n.jsxs("div", { className: "flex items-center gap-2", children: [
                /* @__PURE__ */ n.jsx(
                  F,
                  {
                    control: e,
                    name: `headers.${N}.value`,
                    render: ({ field: O }) => Q?.enum && Q.enum.length > 0 ? /* @__PURE__ */ n.jsx(
                      pe,
                      {
                        shouldFilter: !1,
                        value: O.value,
                        options: Q.enum ?? [],
                        onChange: (P) => {
                          O.onChange(P), i(`headers.${N}.active`, !0);
                        },
                        className: "border-0 p-0 m-0 shadow-none focus-visible:ring-0 bg-transparent hover:bg-transparent text-xs font-mono"
                      }
                    ) : /* @__PURE__ */ n.jsx(
                      me,
                      {
                        placeholder: "Value",
                        className: "w-full truncate border-0 p-0 m-0 shadow-none text-xs focus-visible:ring-0 font-mono",
                        autoComplete: "off",
                        ...O,
                        ref: (P) => {
                          u.current[N] = P;
                        },
                        onKeyDown: (P) => {
                          P.key === "Enter" && P.currentTarget.value.trim() && x(N);
                        }
                      }
                    )
                  }
                ),
                /* @__PURE__ */ n.jsx(
                  re,
                  {
                    size: "icon-xs",
                    variant: "ghost",
                    className: "text-muted-foreground opacity-0 group-hover:brightness-95 group-hover:opacity-100",
                    onClick: () => o(N),
                    type: "button",
                    children: /* @__PURE__ */ n.jsx(jt, { size: 16 })
                  }
                )
              ] })
            ]
          },
          j.id
        );
      })
    ] }) }) }) })
  ] });
}, _r = Ts(
  "text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
), Ue = w.forwardRef(({ className: e, ...t }, s) => /* @__PURE__ */ n.jsx(
  Ot.Root,
  {
    ref: s,
    className: v(_r(), e),
    ...t
  }
));
Ue.displayName = Ot.Root.displayName;
const Zt = w.forwardRef(({ className: e, ...t }, s) => /* @__PURE__ */ n.jsx(
  ae.Root,
  {
    className: v("grid gap-2", e),
    ...t,
    ref: s
  }
));
Zt.displayName = ae.Root.displayName;
const Yt = w.forwardRef(({ className: e, ...t }, s) => /* @__PURE__ */ n.jsx(
  ae.Item,
  {
    ref: s,
    className: v(
      "aspect-square h-4 w-4 rounded-full border border-primary text-primary ring-offset-background focus:outline-hidden focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
      e
    ),
    ...t,
    children: /* @__PURE__ */ n.jsx(ae.Indicator, { className: "flex items-center justify-center", children: /* @__PURE__ */ n.jsx(Ln, { className: "h-2.5 w-2.5 fill-current text-current" }) })
  }
));
Yt.displayName = ae.Item.displayName;
const Kt = ({
  identities: e,
  setValue: t,
  value: s
}) => /* @__PURE__ */ n.jsx("div", { className: "w-full overflow-hidden", children: /* @__PURE__ */ n.jsx(
  Zt,
  {
    onValueChange: (a) => t(a),
    value: s,
    defaultValue: se,
    className: "gap-0",
    disabled: e?.length === 0,
    children: [{ id: se, label: "None" }, ...e ?? []].map(
      (a) => /* @__PURE__ */ n.jsxs(
        Ue,
        {
          className: "h-10 items-center border-b font-normal flex gap-4 p-4 cursor-pointer hover:bg-accent/75",
          children: [
            /* @__PURE__ */ n.jsx(Yt, { value: a.id, id: a.id }),
            /* @__PURE__ */ n.jsx("span", { children: a.label })
          ]
        },
        a.id
      )
    )
  }
) }), Ur = ({
  onSubmit: e,
  identities: t,
  open: s,
  onOpenChange: a
}) => {
  const [r, o] = k(void 0), [i, l] = k(!1);
  return /* @__PURE__ */ n.jsx(Ie, { open: s, onOpenChange: a, children: /* @__PURE__ */ n.jsxs(ke, { children: [
    /* @__PURE__ */ n.jsx(De, { children: "Select an auth identity" }),
    /* @__PURE__ */ n.jsx(Tt, { children: "Please select an identity for this request." }),
    /* @__PURE__ */ n.jsx(Ss, { className: "max-h-80 overflow-auto", children: /* @__PURE__ */ n.jsx(
      Kt,
      {
        identities: t,
        setValue: o,
        value: r
      }
    ) }),
    /* @__PURE__ */ n.jsxs(At, { className: "flex flex-col gap-2", children: [
      /* @__PURE__ */ n.jsxs("div", { className: "flex items-center gap-2", children: [
        /* @__PURE__ */ n.jsx(
          ye,
          {
            id: "remember",
            checked: i,
            onCheckedChange: (c) => l(
              c === "indeterminate" ? !1 : !!c
            )
          }
        ),
        /* @__PURE__ */ n.jsx(Ue, { htmlFor: "remember", children: "Remember my choice" })
      ] }),
      /* @__PURE__ */ n.jsx(
        E,
        {
          onClick: () => e({ identity: r, rememberedIdentity: i }),
          children: "Send"
        }
      )
    ] })
  ] }) });
}, Se = (e) => Math.abs(
  isNaN(parseInt(e)) ? e.toLowerCase().charCodeAt(0) - 96 : isNaN(parseInt(e)) ? 0 : parseInt(e)
), Te = (e) => e.length > 1 ? parseInt(e.split("").reduce((t, s) => `${Se(t) + Se(s)}`)) : Se(e), ft = (e, t = {}) => {
  const s = (3 * Te(e) + 2 * Te(e) + Te(e)) % 360, { saturation: a = 75, lightness: r = 60 } = t;
  return `${s}deg ${a}% ${r}%`;
}, Ae = "data-linked-param", Mr = (e) => {
  const { resolvedTheme: t } = As();
  return {
    text: ft(
      e,
      t === "light" ? { saturation: 95, lightness: 38 } : {}
    ),
    background: ft(
      e,
      t === "light" ? { saturation: 85, lightness: 40 } : {}
    )
  };
}, en = ({
  name: e,
  className: t,
  slug: s,
  title: a,
  children: r,
  onClick: o
}) => {
  const i = L(null), l = s?.replace(/[{}]/g, ""), c = e.replace(/[{}]/g, ""), { text: u, background: d } = Mr(c), h = `hsl(${u} / 100%)`, f = `hsl(${d} / 10%)`, m = `hsl(${d} / 50%)`;
  return z(() => {
    if (!l || !i.current) return;
    const x = () => {
      document.querySelectorAll(`[${Ae}="${l}"]`).forEach((R) => {
        R instanceof HTMLElement && (R.dataset.active = "true");
      });
    }, y = () => {
      document.querySelectorAll(`[${Ae}="${l}"]`).forEach((R) => {
        R instanceof HTMLElement && (R.dataset.active = "false");
      });
    }, b = i.current;
    return b.addEventListener("mouseenter", x), b.addEventListener("mouseleave", y), () => {
      b.removeEventListener("mouseenter", x), b.removeEventListener("mouseleave", y);
    };
  }, [l]), /* @__PURE__ */ n.jsx(
    "span",
    {
      [Ae]: l,
      className: v(
        // This may not contain (inline-)flex or (inline-)block otherwise it breaks the browser's full text search
        "relative transition-all duration-100 rounded-lg",
        "border border-(--border-color) p-0.5 text-(--param-color) bg-(--background-color)",
        "data-[active=true]:border-(--param-color) data-[active=true]:shadow-sm data-[active=true]:bottom-px",
        t
      ),
      title: a,
      suppressHydrationWarning: !0,
      ref: i,
      onClick: o,
      style: {
        "--param-color": h,
        "--border-color": m,
        "--background-color": f
      },
      children: r ?? e
    }
  );
}, Gr = ({
  control: e,
  url: t
}) => {
  const { fields: s } = ze({
    control: e,
    name: "pathParams"
  }), a = [...s].sort(
    (r, o) => t.indexOf(`{${r.name}}`) - t.indexOf(`{${o.name}}`)
  );
  return /* @__PURE__ */ n.jsx("div", { className: "overflow-hidden", children: /* @__PURE__ */ n.jsx(_e, { children: a.map((r, o) => /* @__PURE__ */ n.jsxs(he, { children: [
    /* @__PURE__ */ n.jsx(
      F,
      {
        control: e,
        name: `pathParams.${o}.name`,
        render: () => /* @__PURE__ */ n.jsx("div", { className: "flex items-center", children: /* @__PURE__ */ n.jsx(
          en,
          {
            slug: r.name,
            name: r.name,
            className: "font-mono text-xs px-2"
          }
        ) })
      }
    ),
    /* @__PURE__ */ n.jsx("div", { className: "flex justify-between items-center col-span-2", children: /* @__PURE__ */ n.jsx(
      F,
      {
        control: e,
        name: `pathParams.${o}.value`,
        render: ({ field: i }) => /* @__PURE__ */ n.jsx(
          me,
          {
            ...i,
            required: !0,
            placeholder: "Value",
            className: "w-full truncate border-0 p-0 m-0 shadow-none text-xs font-mono focus-visible:ring-0"
          }
        )
      }
    ) })
  ] }, r.id)) }) });
}, Hr = ce(
  "input",
  "bg-transparent h-9 font-mono text-xs"
), Qr = ({
  control: e,
  schemaQueryParams: t
}) => {
  const { fields: s, remove: a, append: r } = ze({
    control: e,
    name: "queryParams"
  }), { setValue: o, getValues: i, watch: l } = ie(), c = l("queryParams");
  z(() => {
    c.length === 0 && r({ name: "", value: "", active: !1 }, { shouldFocus: !0 });
  }, [c, r]);
  const u = t.map(
    (d) => !!d.isRequired
  );
  return /* @__PURE__ */ n.jsxs(q, { defaultOpen: !0, children: [
    /* @__PURE__ */ n.jsxs(M, { children: [
      /* @__PURE__ */ n.jsx($n, { size: 16 }),
      /* @__PURE__ */ n.jsx(G, { children: "Query Parameters" }),
      /* @__PURE__ */ n.jsxs(
        E,
        {
          onClick: () => {
            o("queryParams", [
              ...i("queryParams"),
              { name: "", value: "", active: !1 }
            ]);
          },
          type: "button",
          size: "sm",
          variant: "ghost",
          className: "hover:bg-accent hover:brightness-95 flex gap-2",
          children: [
            "Add parameter ",
            /* @__PURE__ */ n.jsx(fe, { size: 16 })
          ]
        }
      )
    ] }),
    /* @__PURE__ */ n.jsx(V, { className: "CollapsibleContent", children: /* @__PURE__ */ n.jsx("div", { className: "overflow-hidden w-full", children: /* @__PURE__ */ n.jsx(_e, { children: s.map((d, h) => {
      const f = t.find(
        (m) => m.name === c.at(h)?.name
      );
      return /* @__PURE__ */ n.jsxs(he, { children: [
        /* @__PURE__ */ n.jsx(
          F,
          {
            control: e,
            name: `queryParams.${h}.active`,
            render: ({ field: m }) => /* @__PURE__ */ n.jsx(
              ye,
              {
                id: `queryParams.${h}.active`,
                checked: m.value,
                onCheckedChange: m.onChange
              }
            )
          }
        ),
        /* @__PURE__ */ n.jsx(
          F,
          {
            control: e,
            render: ({ field: m }) => u[h] ? /* @__PURE__ */ n.jsx(Hr, { asChild: !0, children: /* @__PURE__ */ n.jsxs(
              "label",
              {
                className: "flex items-center cursor-pointer gap-1",
                htmlFor: `queryParams.${h}.active`,
                title: u[h] ? "Required field" : void 0,
                children: [
                  m.value,
                  u[h] && /* @__PURE__ */ n.jsx("sup", { children: " *" })
                ]
              }
            ) }) : /* @__PURE__ */ n.jsx(
              pe,
              {
                placeholder: "Name",
                value: m.value,
                options: t.map((x) => x.name),
                onChange: (x) => {
                  m.onChange(x);
                },
                className: "border-0 p-0 m-0 shadow-none focus-visible:ring-0 bg-transparent hover:bg-transparent text-xs font-mono"
              }
            ),
            name: `queryParams.${h}.name`
          }
        ),
        /* @__PURE__ */ n.jsxs("div", { className: "flex justify-between items-center", children: [
          /* @__PURE__ */ n.jsx(
            F,
            {
              control: e,
              render: ({ field: m }) => f?.enum && f.enum.length > 0 ? /* @__PURE__ */ n.jsx(
                pe,
                {
                  value: m.value,
                  options: f.enum ?? [],
                  onChange: (y) => {
                    m.onChange(y), o(`queryParams.${h}.active`, !0);
                  },
                  className: "border-0 shadow-none focus-visible:ring-0 bg-transparent hover:bg-transparent text-xs font-mono"
                }
              ) : /* @__PURE__ */ n.jsx(
                me,
                {
                  ...m,
                  onChange: (y) => {
                    m.onChange(y.target.value), y.target.value.length > 0 && o(`queryParams.${h}.active`, !0);
                  },
                  placeholder: "Value",
                  "aria-label": "Query parameter value",
                  className: "w-full border-0 p-0 m-0 shadow-none focus-visible:ring-0 text-xs font-mono"
                }
              ),
              name: `queryParams.${h}.value`
            }
          ),
          /* @__PURE__ */ n.jsx(
            E,
            {
              size: "icon-xs",
              variant: "ghost",
              className: "text-muted-foreground opacity-0 group-hover:brightness-95 group-hover:opacity-100",
              onClick: () => a(h),
              type: "button",
              children: /* @__PURE__ */ n.jsx(jt, { size: 16 })
            }
          )
        ] })
      ] }, d.id);
    }) }) }) })
  ] });
}, Jr = $e()(
  Ee(
    (e, t) => ({
      rememberedIdentity: null,
      setRememberedIdentity: (s) => e({ rememberedIdentity: s }),
      getRememberedIdentity: (s) => s.find(
        (a) => a === t().rememberedIdentity
      )
    }),
    {
      name: "identity-storage",
      storage: Nt(() => sessionStorage)
    }
  )
), Wr = ({
  path: e,
  renderParam: t
}) => {
  let s = 0;
  return e.split("/").map((a, r, o) => {
    const i = Array.from(a.matchAll(/{([^}]+)}/g)), l = [];
    let c = 0;
    return i.forEach((u) => {
      const [d, h] = u;
      if (!h) return;
      const f = u.index;
      f > c && l.push(
        /* @__PURE__ */ n.jsx(ee, { children: a.slice(c, f) }, `text-${c}-${f}`)
      ), l.push(
        /* @__PURE__ */ n.jsx(ee, { children: t({ name: h, originalValue: d, index: s++ }) }, `param-${h}`)
      ), c = f + d.length;
    }), c < a.length && l.push(
      /* @__PURE__ */ n.jsx(ee, { children: a.slice(c) }, `text-${c}-${a.length}`)
    ), // eslint-disable-next-line react/no-array-index-key
    /* @__PURE__ */ n.jsxs(ee, { children: [
      l,
      r < o.length - 1 && "/",
      /* @__PURE__ */ n.jsx("wbr", {})
    ] }, `${a}-${r}`);
  });
}, Xr = ({ url: e }) => {
  const { watch: t, setFocus: s } = ie(), [a] = t(["pathParams"]);
  return /* @__PURE__ */ n.jsx(
    Wr,
    {
      path: e,
      renderParam: ({ name: r, originalValue: o, index: i }) => {
        const l = a.find(
          (c) => c.name === r
        )?.value;
        return /* @__PURE__ */ n.jsx(
          en,
          {
            name: r,
            backgroundOpacity: "0",
            slug: r,
            onClick: () => s(`pathParams.${i}.value`),
            children: l || o
          }
        );
      }
    }
  );
}, Zr = () => {
  const { watch: e } = ie(), s = e("queryParams").filter((a) => a.active && a.name).map((a, r, o) => /* @__PURE__ */ n.jsxs(ee, { children: [
    a.name,
    "=",
    encodeURIComponent(a.value).replaceAll("%20", "+"),
    r < o.length - 1 && "&",
    /* @__PURE__ */ n.jsx("wbr", {})
  ] }, a.name));
  return /* @__PURE__ */ n.jsxs(n.Fragment, { children: [
    s.length > 0 ? "?" : "",
    s
  ] });
}, Yr = ({
  open: e,
  setOpen: t,
  onSignUp: s,
  onLogin: a
}) => /* @__PURE__ */ n.jsx(Ie, { open: e, onOpenChange: t, children: /* @__PURE__ */ n.jsxs(ke, { children: [
  /* @__PURE__ */ n.jsx(De, { children: "Welcome to the Playground!" }),
  /* @__PURE__ */ n.jsx(Tt, { children: "The Playground is a tool for developers to test and explore our APIs. To use the Playground, you need to login." }),
  /* @__PURE__ */ n.jsxs(At, { className: "flex gap-2 sm:justify-between", children: [
    /* @__PURE__ */ n.jsx(E, { type: "button", variant: "ghost", onClick: () => t(!1), children: "Skip" }),
    /* @__PURE__ */ n.jsxs("div", { className: "flex gap-2", children: [
      s && /* @__PURE__ */ n.jsx(E, { type: "button", variant: "outline", onClick: s, children: "Sign Up" }),
      a && /* @__PURE__ */ n.jsx(E, { type: "button", variant: "default", onClick: a, children: "Login" })
    ] })
  ] })
] }) }), tn = (e = 0) => {
  if (e === 0)
    return "0 B";
  const t = Math.floor(Math.log(e) / Math.log(1e3));
  return `${(e / Math.pow(1e3, t)).toFixed(
    t ? 2 : 0
  )} ${t ? `${"kMGTPEZY"[t - 1]}B` : "B"}`;
}, Kr = ({ status: e }) => {
  if (!e) return /* @__PURE__ */ n.jsx("div", { className: "w-2 h-2 rounded-full bg-gray-500" });
  switch (Number(e.toString().slice(0, 1))) {
    case 2:
      return /* @__PURE__ */ n.jsx("div", { className: "w-2 h-2 rounded-full bg-green-500" });
    case 4:
      return /* @__PURE__ */ n.jsx("div", { className: "w-2 h-2 rounded-full bg-yellow-400" });
    case 5:
      return /* @__PURE__ */ n.jsx("div", { className: "w-2 h-2 rounded-full bg-red-500" });
    default:
      return /* @__PURE__ */ n.jsx("div", { className: "w-2 h-2 rounded-full bg-gray-500" });
  }
}, ea = () => {
  const e = L(null), t = L(null), s = L(Date.now()), a = L(null), r = St(() => {
    if (t.current) {
      const o = Date.now() - s.current;
      t.current.nodeValue = o.toFixed();
    }
    a.current = requestAnimationFrame(r);
  }, []);
  return ns(() => {
    const o = document.createTextNode("0"), i = e.current;
    return i.appendChild(o), t.current = o, s.current = Date.now(), a.current = requestAnimationFrame(r), () => {
      a.current && cancelAnimationFrame(a.current), t.current && i.contains(o) && i.removeChild(o);
    };
  }, [r]), /* @__PURE__ */ n.jsx("span", { className: "inline-block text-end w-[3ch]", ref: e });
}, ta = ({
  status: e,
  time: t,
  size: s,
  isFinished: a,
  progress: r
}) => {
  const o = {
    200: "OK",
    201: "Created",
    202: "Accepted",
    204: "No Content",
    400: "Bad Request",
    401: "Unauthorized",
    403: "Forbidden",
    404: "Not Found",
    405: "Method Not Allowed",
    500: "Internal Server Error"
  };
  return /* @__PURE__ */ n.jsxs("div", { className: "relative flex h-10 text-xs gap-4 px-4 items-center justify-between font-mono border-b", children: [
    /* @__PURE__ */ n.jsxs("div", { className: "flex items-center gap-2", children: [
      /* @__PURE__ */ n.jsx(Kr, { status: e }),
      " ",
      e ?? "Sending Request...",
      e ? ` ${o[e]}` : ""
    ] }),
    /* @__PURE__ */ n.jsxs("div", { className: "flex gap-2", children: [
      /* @__PURE__ */ n.jsxs("div", { children: [
        /* @__PURE__ */ n.jsx("span", { className: "text-muted-foreground", children: "Size" }),
        " ",
        /* @__PURE__ */ n.jsx("span", { className: "inline-block text-end min-w-[5ch]", children: s ? tn(s) : "- B" })
      ] }),
      /* @__PURE__ */ n.jsxs("div", { children: [
        /* @__PURE__ */ n.jsx("span", { className: "text-muted-foreground", children: "Time" }),
        " ",
        t !== void 0 ? `${t.toFixed(0)}` : /* @__PURE__ */ n.jsx(ea, {}),
        "ms"
      ] })
    ] }),
    /* @__PURE__ */ n.jsx(
      "div",
      {
        className: "h-full bg-neutral-500/10 absolute left-0 -bottom-0 z-10 transition-all duration-200 ease-in-out",
        style: {
          opacity: a ? 0 : 1,
          width: a ? 0 : `${r * 100}%`
        }
      }
    )
  ] });
};
function Me(e) {
  if (e === null) return "null";
  if (Array.isArray(e)) {
    if (e.length === 0) return "any[]";
    const t = e[0];
    return t === void 0 ? "any[]" : `${Me(t)}[]`;
  }
  return typeof e == "object" ? na(e) : typeof e;
}
function na(e, t = "") {
  const s = ["{"];
  for (const [a, r] of Object.entries(e)) {
    const o = Me(r);
    s.push(`  ${a}: ${o};`);
  }
  return s.push("}"), s.join(`
`);
}
function sa(e) {
  return { lines: [`type GeneratedType = ${Me(e)};`] };
}
const nn = ({
  code: e,
  language: t,
  children: s
}) => {
  const { syntaxHighlighting: a } = Jn().options;
  return es(a?.highlighter, "Highlighter not found"), Os(
    a.highlighter,
    e ?? s ?? "",
    t,
    a.themes
  );
};
nn.displayName = "Highlight";
const ra = (e) => Object.entries({
  "application/json": "json",
  "text/json": "json",
  "text/html": "html",
  "text/css": "css",
  "text/javascript": "javascript",
  "application/xml": "xml",
  "application/xhtml+xml": "xhtml"
}).find(
  ([s]) => e.includes(s)
)?.[1], aa = (e) => {
  const t = e.find(([s]) => s.toLowerCase() === "content-type")?.[1] || "";
  return ra(t);
}, oa = (e) => {
  try {
    return JSON.stringify(JSON.parse(e), null, 2);
  } catch {
    return null;
  }
}, ia = (e) => {
  const t = [
    "Content-Type",
    "Content-Length",
    "Authorization",
    "X-RateLimit-Remaining",
    "X-RateLimit-Limit",
    "Cache-Control",
    "ETag"
  ].map((s) => s.toLowerCase());
  return [...e].sort(([s], [a]) => {
    const r = t.indexOf(s.toLowerCase()), o = t.indexOf(a.toLowerCase());
    return r === o ? 0 : r === -1 ? 1 : o === -1 ? -1 : r - o;
  });
}, K = 3, Oe = ce(
  "div",
  "grid-cols-subgrid grid border-b col-span-full px-4 py-1.5 font-mono text-xs"
), Z = ce("div", "py-1 break-all"), ca = ({
  body: e = "",
  headers: t,
  request: s,
  size: a,
  isBinary: r = !1,
  fileName: o,
  blob: i
}) => {
  const l = aa(t), c = oa(e), u = c || e, [d, h] = k(
    c ? "formatted" : "raw"
  ), f = Wn({
    queryKey: ["types", u],
    queryFn: async () => sa(JSON.parse(u)),
    enabled: d === "types" && !r
  }), m = () => {
    if (i && o) {
      const y = URL.createObjectURL(i), b = document.createElement("a");
      b.href = y, b.download = o, document.body.appendChild(b), b.click(), document.body.removeChild(b), URL.revokeObjectURL(y);
    }
  }, x = ia([...t]);
  return /* @__PURE__ */ n.jsxs(n.Fragment, { children: [
    /* @__PURE__ */ n.jsxs(q, { defaultOpen: !0, children: [
      /* @__PURE__ */ n.jsxs(M, { children: [
        /* @__PURE__ */ n.jsx(En, { size: 16 }),
        /* @__PURE__ */ n.jsx(G, { className: "col-span-2", children: "Header Request" })
      ] }),
      /* @__PURE__ */ n.jsx(V, { children: /* @__PURE__ */ n.jsx("div", { className: "grid grid-cols-2 gap-x-6 text-sm", children: s.headers.slice(0, K).map(([y, b]) => /* @__PURE__ */ n.jsxs(Oe, { children: [
        /* @__PURE__ */ n.jsx(Z, { children: y }),
        /* @__PURE__ */ n.jsx(Z, { children: b })
      ] }, y)) }) })
    ] }),
    /* @__PURE__ */ n.jsxs(q, { defaultOpen: !0, children: [
      /* @__PURE__ */ n.jsxs(M, { children: [
        /* @__PURE__ */ n.jsx(In, { size: 16 }),
        /* @__PURE__ */ n.jsx(G, { className: "col-span-2", children: "Header Response" })
      ] }),
      /* @__PURE__ */ n.jsx(V, { children: /* @__PURE__ */ n.jsxs("div", { className: "grid grid-cols-2 gap-x-6 text-sm", children: [
        x.slice(0, K).map(([y, b]) => /* @__PURE__ */ n.jsxs(Oe, { children: [
          /* @__PURE__ */ n.jsx(Z, { children: y }),
          /* @__PURE__ */ n.jsx(Z, { children: b })
        ] }, y)),
        x.length > K && /* @__PURE__ */ n.jsxs(q, { className: "col-span-full grid-cols-subgrid grid group", children: [
          /* @__PURE__ */ n.jsxs(Vt, { className: "data-[state=open]:hidden justify-center col-span-2 text-xs text-muted-foreground hover:text-primary border-b h-8 flex items-center gap-2", children: [
            /* @__PURE__ */ n.jsxs("span", { children: [
              "Show ",
              x.length - K,
              " more headers"
            ] }),
            /* @__PURE__ */ n.jsx(fe, { size: 12, className: "text-muted-foreground" })
          ] }),
          /* @__PURE__ */ n.jsx(V, { className: "col-span-full grid grid-cols-subgrid", children: x.slice(K).map(([y, b]) => /* @__PURE__ */ n.jsxs(Oe, { children: [
            /* @__PURE__ */ n.jsx(Z, { children: y }),
            /* @__PURE__ */ n.jsx(Z, { children: b })
          ] }, y)) })
        ] })
      ] }) })
    ] }),
    /* @__PURE__ */ n.jsx("div", { className: "flex gap-2 justify-between items-center border-b h-10", children: c && !r && /* @__PURE__ */ n.jsx("div", { className: "px-2", children: /* @__PURE__ */ n.jsxs(
      Bt,
      {
        value: d,
        onValueChange: (y) => h(y),
        children: [
          /* @__PURE__ */ n.jsx(Ve, { className: "min-w-32 border-none h-8", children: /* @__PURE__ */ n.jsx(_t, { placeholder: "View" }) }),
          /* @__PURE__ */ n.jsxs(Be, { children: [
            /* @__PURE__ */ n.jsx(ne, { value: "formatted", children: "Formatted" }),
            /* @__PURE__ */ n.jsx(ne, { value: "raw", children: "Raw" }),
            /* @__PURE__ */ n.jsx(ne, { value: "types", children: "Types" })
          ] })
        ]
      }
    ) }) }),
    /* @__PURE__ */ n.jsx("div", { children: r ? /* @__PURE__ */ n.jsx("div", { className: "p-4 text-center", children: /* @__PURE__ */ n.jsxs("div", { className: "flex flex-col items-center gap-4", children: [
      /* @__PURE__ */ n.jsx("div", { className: "text-lg font-semibold", children: "Binary Content" }),
      /* @__PURE__ */ n.jsx("div", { className: "text-sm text-muted-foreground", children: "This response contains binary data that cannot be displayed as text." }),
      /* @__PURE__ */ n.jsxs(
        E,
        {
          onClick: m,
          className: "flex items-center gap-2",
          disabled: !i,
          children: [
            /* @__PURE__ */ n.jsx(kn, { className: "h-4 w-4" }),
            "Download ",
            o || "file",
            " (",
            tn(a),
            ")"
          ]
        }
      )
    ] }) }) : /* @__PURE__ */ n.jsx("div", { className: "overflow-auto max-w-full p-4 text-xs max-h-[calc(83.333vh-180px)]", children: /* @__PURE__ */ n.jsx(
      nn,
      {
        language: d === "types" ? "typescript" : d === "raw" ? c ? "plain" : l : "json",
        code: (d === "raw" ? e : d === "types" ? f.data?.lines.join(`
`) : u) ?? ""
      }
    ) }) })
  ] });
}, la = ({
  queryMutation: e,
  showLongRunningWarning: t,
  onCancel: s,
  tip: a,
  isFinished: r,
  progress: o
}) => /* @__PURE__ */ n.jsxs("div", { className: "overflow-y-auto h-[80vh] bg-muted/50", children: [
  (e.isPending || e.data) && /* @__PURE__ */ n.jsx(
    ta,
    {
      status: e.data?.status,
      time: e.data?.time,
      size: e.data?.size,
      isFinished: r,
      progress: o
    }
  ),
  e.error ? /* @__PURE__ */ n.jsx("div", { className: "max-w-2/3 mx-auto mt-20", children: /* @__PURE__ */ n.jsxs(ls, { children: [
    /* @__PURE__ */ n.jsx(Dn, { size: 24, strokeWidth: 1.5, className: "me-5" }),
    /* @__PURE__ */ n.jsx(ds, { children: "Request failed" }),
    /* @__PURE__ */ n.jsx(us, { children: e.error.message || String(e.error) || "Unexpected error" })
  ] }) }) : e.data ? /* @__PURE__ */ n.jsx(
    ca,
    {
      request: e.data.request,
      size: e.data.size,
      headers: e.data.headers,
      body: e.data.body,
      isBinary: e.data.isBinary,
      fileName: e.data.fileName,
      blob: e.data.blob
    }
  ) : e.isPending ? /* @__PURE__ */ n.jsx("div", { className: "grid place-items-center h-full", children: /* @__PURE__ */ n.jsxs("div", { className: "flex flex-col gap-2 items-center mt-20", children: [
    /* @__PURE__ */ n.jsx(is, {}),
    /* @__PURE__ */ n.jsxs(
      "div",
      {
        className: v(
          "opacity-0 pointer-events-none transition-opacity h-20 text-sm text-muted-foreground duration-300 flex flex-col gap-2 items-center",
          t && "opacity-100 pointer-events-auto"
        ),
        children: [
          "Looks like the request is taking longer than expected.",
          /* @__PURE__ */ n.jsx(
            re,
            {
              type: "button",
              onClick: s,
              size: "sm",
              className: "w-fit",
              variant: "outline",
              children: "Cancel"
            }
          )
        ]
      }
    )
  ] }) }) : /* @__PURE__ */ n.jsx("div", { className: "h-full grid place-items-center", children: /* @__PURE__ */ n.jsxs("div", { className: "flex flex-col gap-4 items-center", children: [
    /* @__PURE__ */ n.jsx(
      zn,
      {
        size: 64,
        className: "text-muted-foreground",
        strokeWidth: 1.2
      }
    ),
    /* @__PURE__ */ n.jsx("span", { className: "text-[16px] font-semibold text-muted-foreground", children: "Send your first request" }),
    a
  ] }) })
] }), da = $e()(
  Ee(
    (e) => ({
      skipLogin: !1,
      setSkipLogin: (t) => e({ skipLogin: t })
    }),
    {
      name: "remember-skip-login",
      storage: Nt(() => sessionStorage)
    }
  )
), se = "__none", ua = ({
  server: e,
  servers: t = [],
  url: s,
  method: a,
  headers: r = [],
  queryParams: o = [],
  pathParams: i = [],
  defaultBody: l = "",
  examples: c,
  requiresLogin: u = !1,
  onLogin: d,
  onSignUp: h
}) => {
  const { selectedServer: f, setSelectedServer: m } = Tr(
    t.map((p) => ({ url: p }))
  ), [x, y] = k(!1), b = Xn(), { setRememberedIdentity: R, getRememberedIdentity: j } = Jr(), [, N] = ss(), { skipLogin: Q, setSkipLogin: O } = da(), [D, P] = k(!1), J = L(void 0), He = gs(R), Qe = L(null), { label: ln } = Cr("meta+enter", () => {
    Qe.current?.requestSubmit();
  }), Je = s.match(/\{([^}]+)\}/g)?.map((p) => p.slice(1, -1)) ?? [], We = [...i].sort(
    (p, X) => Je.indexOf(p.name) - Je.indexOf(X.name)
  ), { register: dn, control: le, handleSubmit: Xe, watch: Ze, setValue: ve, ...be } = ps({
    defaultValues: {
      body: l,
      queryParams: o.length > 0 ? o.map((p) => ({
        name: p.name,
        value: p.defaultValue ?? "",
        active: p.defaultActive ?? !1,
        enum: p.enum ?? []
      })) : [
        {
          name: "",
          value: "",
          active: !1,
          enum: []
        }
      ],
      pathParams: We.map((p) => ({
        name: p.name,
        value: p.defaultValue ?? ""
      })),
      headers: r.length > 0 ? r.map((p) => ({
        name: p.name,
        value: p.defaultValue ?? "",
        active: p.defaultActive ?? !1
      })) : [
        {
          name: "",
          value: "",
          active: !1
        }
      ],
      identity: j([
        se,
        ...b.data?.map((p) => p.id) ?? []
      ])
    }
  }), W = Ze("identity"), un = Ct(
    () => b.data?.find((p) => p.id === W)?.authorizationFields,
    [b.data, W]
  );
  z(() => {
    W && He.current(W);
  }, [He, W]);
  const B = ms({
    gcTime: 0,
    mutationFn: async (p) => {
      const X = performance.now(), bn = Object.fromEntries([
        ...p.headers.filter((A) => A.name && A.active).map((A) => [A.name, A.value])
      ]), _ = new Request(
        ht(e ?? f, s, p),
        {
          method: a.toUpperCase(),
          headers: bn,
          body: p.body ? p.body : void 0
        }
      );
      p.identity !== se && await b.data?.find((A) => A.id === p.identity)?.authorizeRequest(_);
      const je = setTimeout(
        () => P(!0),
        3210
      );
      J.current = new AbortController(), J.current.signal.addEventListener("abort", () => {
        clearTimeout(je);
      });
      try {
        const A = await fetch(_, {
          cache: "no-store",
          signal: J.current.signal
        });
        clearTimeout(je), P(!1);
        const jn = performance.now() - X, Nn = new URL(_.url), et = Array.from(A.headers.entries()), tt = A.headers.get("content-type") || "", nt = Dr(tt);
        let de = "", st, rt;
        nt ? (st = await A.blob(), rt = zr(et, _.url), de = `Binary content (${tt})`) : de = await A.text();
        const at = A.headers.get("content-length");
        return {
          status: A.status,
          headers: et,
          size: at ? parseInt(at) : de.length,
          body: de,
          time: jn,
          isBinary: nt,
          fileName: rt,
          blob: st,
          request: {
            method: _.method.toUpperCase(),
            url: _.url,
            headers: [
              ["Host", Nn.host],
              ["User-Agent", "Zudoku Playground"],
              ...Array.from(_.headers.entries())
            ],
            body: p.body ? p.body : void 0
          }
        };
      } catch (A) {
        throw clearTimeout(je), P(!1), A instanceof TypeError ? new Error(
          "The request failed, possibly due to network issues or CORS policy."
        ) : A;
      }
    }
  }), Ye = B.isPending, [mn, pn] = k(!1);
  z(() => {
    const p = setTimeout(() => pn(Ye), 100);
    return () => clearTimeout(p);
  }, [Ye]);
  const { isFinished: hn, progress: fn } = cs({ isAnimating: mn });
  z(() => () => {
    J.current?.abort();
  }, []);
  const xn = /* @__PURE__ */ n.jsx("div", { className: "inline-block opacity-50 hover:opacity-100 transition", children: e ? /* @__PURE__ */ n.jsx("span", { children: e.replace(/^https?:\/\//, "").replace(/\/$/, "") }) : t.length > 1 && /* @__PURE__ */ n.jsxs(
    Bt,
    {
      onValueChange: (p) => {
        N(() => m(p));
      },
      value: f,
      defaultValue: f,
      children: [
        /* @__PURE__ */ n.jsx(Ve, { className: "p-0 border-none flex-row-reverse bg-transparent text-xs gap-0.5 h-auto translate-y-[4px]", children: /* @__PURE__ */ n.jsx(_t, {}) }),
        /* @__PURE__ */ n.jsx(Be, { children: t.map((p) => /* @__PURE__ */ n.jsx(ne, { value: p, children: p.replace(/^https?:\/\//, "").replace(/\/$/, "") }, p)) })
      ]
    }
  ) }), gn = u && !Q, yn = ["POST", "PUT", "PATCH", "DELETE"].includes(
    a.toUpperCase()
  ), [Ke, vn] = xs();
  return /* @__PURE__ */ n.jsx(
    hs,
    {
      register: dn,
      control: le,
      handleSubmit: Xe,
      watch: Ze,
      setValue: ve,
      ...be,
      children: /* @__PURE__ */ n.jsx(fs, { delayDuration: 150, children: /* @__PURE__ */ n.jsxs(
        "form",
        {
          ref: Qe,
          onSubmit: Xe((p) => {
            b.data?.length === 0 || p.identity ? B.mutate(p) : y(!0);
          }),
          className: "relative",
          children: [
            /* @__PURE__ */ n.jsx(
              Ur,
              {
                identities: b.data ?? [],
                open: x,
                onOpenChange: y,
                onSubmit: ({ rememberedIdentity: p, identity: X }) => {
                  p && ve("identity", X ?? se), y(!1), B.mutate({ ...be.getValues(), identity: X });
                }
              }
            ),
            /* @__PURE__ */ n.jsx(
              Yr,
              {
                open: gn,
                setOpen: (p) => O(!p),
                onSignUp: h,
                onLogin: d
              }
            ),
            /* @__PURE__ */ n.jsxs("div", { className: "grid grid-cols-[1fr_1px_1fr] text-sm", children: [
              /* @__PURE__ */ n.jsxs("div", { className: "col-span-3 p-4 border-b flex gap-2 items-stretch", children: [
                /* @__PURE__ */ n.jsxs("div", { className: "flex flex-1 items-center w-full border rounded-md relative overflow-hidden", children: [
                  /* @__PURE__ */ n.jsx("div", { className: "border-r p-2 bg-muted rounded-l-md self-stretch font-semibold font-mono flex items-center", children: a.toUpperCase() }),
                  /* @__PURE__ */ n.jsx("div", { className: "items-center px-2 font-mono text-xs break-all leading-6 relative h-full w-full", children: /* @__PURE__ */ n.jsxs("div", { className: "h-full py-1.5", children: [
                    xn,
                    /* @__PURE__ */ n.jsx(Xr, { url: s }),
                    /* @__PURE__ */ n.jsx(Zr, {})
                  ] }) }),
                  /* @__PURE__ */ n.jsx("div", { className: "px-1", children: /* @__PURE__ */ n.jsx(
                    E,
                    {
                      type: "button",
                      onClick: () => {
                        vn(
                          ht(
                            e ?? f,
                            s,
                            be.getValues()
                          ).toString()
                        );
                      },
                      variant: "ghost",
                      size: "icon-xs",
                      className: v(
                        "hover:opacity-100 transition",
                        Ke ? "text-emerald-600 opacity-100" : "opacity-50"
                      ),
                      children: Ke ? /* @__PURE__ */ n.jsx(bt, { className: "text-green-500", size: 14 }) : /* @__PURE__ */ n.jsx(Fn, { size: 14 })
                    }
                  ) })
                ] }),
                /* @__PURE__ */ n.jsx(
                  E,
                  {
                    type: "submit",
                    variant: B.isPending ? "destructive" : "default",
                    onClick: (p) => {
                      B.isPending && (J.current?.abort(
                        "Request cancelled by user"
                      ), p.preventDefault());
                    },
                    className: "w-18",
                    children: B.isPending ? "Cancel" : "Send"
                  }
                )
              ] }),
              /* @__PURE__ */ n.jsxs("div", { className: "relative overflow-y-auto h-[80vh]", children: [
                b.data?.length !== 0 && /* @__PURE__ */ n.jsxs(q, { defaultOpen: !0, children: [
                  /* @__PURE__ */ n.jsxs(M, { children: [
                    /* @__PURE__ */ n.jsx(qn, { size: 16 }),
                    /* @__PURE__ */ n.jsx(G, { className: "col-span-2", children: "Authentication" })
                  ] }),
                  /* @__PURE__ */ n.jsx(V, { className: "CollapsibleContent", children: /* @__PURE__ */ n.jsx(
                    Kt,
                    {
                      value: W,
                      identities: b.data ?? [],
                      setValue: (p) => ve("identity", p)
                    }
                  ) })
                ] }),
                We.length > 0 && /* @__PURE__ */ n.jsxs(q, { defaultOpen: !0, children: [
                  /* @__PURE__ */ n.jsxs(M, { children: [
                    /* @__PURE__ */ n.jsx(Vn, { size: 16 }),
                    /* @__PURE__ */ n.jsx(G, { className: "col-span-2", children: "Path Parameters" })
                  ] }),
                  /* @__PURE__ */ n.jsx(V, { className: "CollapsibleContent", children: /* @__PURE__ */ n.jsx(Gr, { url: s, control: le }) })
                ] }),
                /* @__PURE__ */ n.jsx(Qr, { control: le, schemaQueryParams: o }),
                /* @__PURE__ */ n.jsx(
                  Br,
                  {
                    control: le,
                    schemaHeaders: r,
                    lockedHeaders: un?.headers
                  }
                ),
                yn && /* @__PURE__ */ n.jsx(kr, { content: c })
              ] }),
              /* @__PURE__ */ n.jsx("div", { className: "w-full bg-muted-foreground/20" }),
              /* @__PURE__ */ n.jsx(
                la,
                {
                  queryMutation: B,
                  showLongRunningWarning: D,
                  isFinished: hn,
                  progress: fn,
                  tip: /* @__PURE__ */ n.jsx("div", { className: "text-xs w-full", children: /* @__PURE__ */ n.jsxs("span", { className: "text-muted-foreground", children: [
                    "Press",
                    " ",
                    /* @__PURE__ */ n.jsx("kbd", { className: "text-foreground border rounded m-0.5 px-1 py-0.5 capitalize", children: ln.join(" + ") }),
                    " ",
                    "to send a request"
                  ] }) }),
                  onCancel: () => {
                    J.current?.abort(
                      "Request cancelled by the user"
                    ), P(!1);
                  }
                }
              )
            ] })
          ]
        }
      ) })
    }
  );
}, ma = ({
  className: e,
  size: t = 16
}) => /* @__PURE__ */ n.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    className: e,
    width: t,
    height: t,
    children: /* @__PURE__ */ n.jsx(
      "path",
      {
        fillRule: "evenodd",
        d: "M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm14.024-.983a1.125 1.125 0 0 1 0 1.966l-5.603 3.113A1.125 1.125 0 0 1 9 15.113V8.887c0-.857.921-1.4 1.671-.983l5.603 3.113Z",
        clipRule: "evenodd"
      }
    )
  }
), pa = (e) => {
  const [t, s] = k(!1);
  return /* @__PURE__ */ n.jsxs(Ie, { onOpenChange: (a) => s(a), children: [
    /* @__PURE__ */ n.jsx(os, { asChild: !0, children: e.children ?? /* @__PURE__ */ n.jsxs(
      "button",
      {
        type: "button",
        className: "flex gap-1 items-center px-2 py-1 rounded-md transition text-xs bg-primary  text-primary-foreground shadow-xs hover:bg-primary/80",
        children: [
          "Test",
          /* @__PURE__ */ n.jsx(ma, { size: 14 })
        ]
      }
    ) }),
    /* @__PURE__ */ n.jsxs(
      ke,
      {
        className: "max-w-screen-xl w-full overflow-hidden p-0",
        "aria-describedby": void 0,
        showCloseButton: !0,
        children: [
          /* @__PURE__ */ n.jsx(as, { children: /* @__PURE__ */ n.jsx(De, { children: "Playground" }) }),
          t && /* @__PURE__ */ n.jsx(ua, { ...e })
        ]
      }
    )
  ] });
}, ha = {
  get: "green",
  post: "blue",
  put: "yellow",
  delete: "red",
  patch: "purple",
  options: "gray",
  head: "gray"
}, xt = ({
  label: e,
  path: t,
  operations: s,
  collapsible: a,
  collapsed: r
}) => ({
  type: "category",
  label: e,
  link: {
    type: "doc",
    path: t,
    file: t,
    label: e
  },
  collapsible: a,
  collapsed: r,
  items: s.map((o) => ({
    type: "link",
    label: o.summary ?? o.path,
    to: `${t}#${o.slug}`,
    badge: {
      label: o.method,
      color: ha[o.method.toLowerCase()],
      invert: !0
    }
  }))
}), sn = wt(
  void 0
), Wa = sn.Provider, fa = () => {
  const e = rs(sn);
  if (!e)
    throw new Error("useOasConfig must be used within a OasConfigProvider");
  return e.config;
}, gt = (e) => ({
  path: e.routePath,
  async lazy() {
    const { OasProvider: t } = await import("./OasProvider-CbwsKPNc.js");
    return {
      element: /* @__PURE__ */ n.jsx(
        t,
        {
          basePath: e.basePath,
          version: e.version,
          client: e.client,
          config: e.config
        }
      )
    };
  },
  children: e.routes
}), rn = ({
  path: e,
  tag: t,
  untagged: s
}) => ({
  path: e,
  async lazy() {
    const { OperationList: a } = await import("./OperationList-Bn9ggxw8.js");
    return { element: /* @__PURE__ */ n.jsx(a, { tag: t, untagged: s }) };
  }
}), xa = ({
  render: e,
  path: t
}) => {
  const { type: s, input: a } = fa(), { tag: r } = Mn(), o = Gn(), i = lr(cn, { type: s, input: a }), {
    data: { schema: l }
  } = Zn(i), c = l.tags.at(0);
  return !r && c?.slug ? /* @__PURE__ */ n.jsx(
    Hn,
    {
      to: {
        pathname: Qn(t, { tag: c.slug }),
        search: o.search
      }
    }
  ) : r && l.tags.some((u) => u.slug === r) ? e(r) : null;
}, ga = ({ path: e }) => ({
  path: e,
  async lazy() {
    const { OperationList: t } = await import("./OperationList-Bn9ggxw8.js");
    return {
      element: /* @__PURE__ */ n.jsx(
        xa,
        {
          path: e,
          render: (s) => /* @__PURE__ */ n.jsx(t, { tag: s })
        }
      )
    };
  }
}), an = (e) => [
  // Category without tagged operations
  rn({
    path: I(e, Ge),
    untagged: !0
  }),
  // Schema list route
  {
    path: I(e, "~schemas"),
    lazy: async () => {
      const { SchemaList: t } = await import("./SchemaList-DETyCVqu.js");
      return { element: /* @__PURE__ */ n.jsx(t, {}) };
    }
  }
], ya = (e, t) => {
  const s = I(e, t.at(0) ?? Ge);
  return [
    // Redirect to first tag on the index route
    { index: !0, loader: () => Un(s) },
    // Create routes for each tag
    ...t.map(
      (a) => rn({
        path: I(e, a),
        tag: a
      })
    ),
    ...an(e)
  ];
}, on = (e) => e.type === "file" ? Object.keys(e.input) : [], va = ({
  basePath: e,
  config: t,
  client: s
}) => {
  const a = t.tagPages;
  if (!a)
    return [
      gt({
        basePath: e,
        routePath: e,
        routes: [
          ga({ path: e + "/:tag?" }),
          ...an(e)
        ],
        client: s,
        config: t
      })
    ];
  const r = on(t);
  return (r.length > 1 ? [void 0, ...r] : [void 0]).map((i) => {
    const l = I(e, i);
    return gt({
      basePath: e,
      version: i,
      routePath: l,
      routes: ya(l, a),
      client: s,
      config: t
    });
  });
}, cn = yr(`
  query GetNavigationOperations($input: JSON!, $type: SchemaType!) {
    schema(input: $input, type: $type) {
      tags {
        slug
        name
        extensions
        operations {
          summary
          slug
          method
          operationId
          path
        }
      }
      components {
        schemas {
          __typename
        }
      }
    }
  }
`), Ge = "~endpoints", Xa = (e) => {
  const t = I(e.path), s = new Ps(e);
  return {
    getHead: () => {
      if (e.type === "url" && !e.skipPreload)
        return /* @__PURE__ */ n.jsx(
          "link",
          {
            rel: "preload",
            href: e.input,
            as: "fetch",
            crossOrigin: "anonymous"
          }
        );
      if (e.server)
        return /* @__PURE__ */ n.jsx("link", { rel: "preconnect", href: e.server });
    },
    getMdxComponents: () => ({
      OpenPlaygroundButton: ({
        requireAuth: a,
        server: r,
        method: o,
        url: i,
        children: l,
        ...c
      }) => {
        const u = Yn();
        if (!r)
          throw new Error("Server is required");
        return a && !u.isAuthenticated ? /* @__PURE__ */ n.jsxs(
          re,
          {
            className: "gap-2 items-center",
            variant: "outline",
            onClick: u.login,
            children: [
              "Login to open in Playground ",
              /* @__PURE__ */ n.jsx(Bn, { size: 16 })
            ]
          }
        ) : /* @__PURE__ */ n.jsx(
          pa,
          {
            url: i ?? "/",
            method: o ?? "get",
            server: r,
            ...c,
            children: /* @__PURE__ */ n.jsx(re, { className: "gap-2 items-center", variant: "outline", children: l ?? /* @__PURE__ */ n.jsxs(n.Fragment, { children: [
              "Open in Playground ",
              /* @__PURE__ */ n.jsx(_n, { size: 16 })
            ] }) })
          }
        );
      }
    }),
    getNavigation: async (a, r) => {
      if (!ot({ path: t, end: !1 }, a))
        return [];
      const o = ot(
        { path: `${t}/:version?/:tag`, end: !0 },
        a
      );
      try {
        const i = o?.params.version, l = i ?? on(e).at(0), { type: c } = e, u = c === "file" ? e.input[l] : e.input, d = qt(s, cn, {
          type: c,
          input: u
        }), h = await r.queryClient.ensureQueryData(d), f = h.schema.tags.flatMap((x) => {
          if (!x.name || x.operations.length === 0) return [];
          const y = I(t, i, x.slug), b = x.extensions?.["x-zudoku-collapsed"] ?? !e.options?.expandAllTags, R = x.extensions?.["x-zudoku-collapsible"] ?? !0;
          return xt({
            label: x.name,
            path: y,
            operations: x.operations,
            collapsed: b,
            collapsible: R
          });
        }), m = h.schema.tags.find(
          (x) => !x.name
        )?.operations;
        return m && f.push(
          xt({
            label: f.length === 0 ? "Endpoints" : "Other endpoints",
            path: I(t, i, Ge),
            operations: m,
            collapsed: !e.options?.expandAllTags
          })
        ), h.schema.components?.schemas?.length && f.push({
          type: "link",
          label: "Schemas",
          to: I(t, i, "~schemas")
        }), f;
      } catch {
        return [];
      }
    },
    getRoutes: () => va({ basePath: t, config: e, client: s })
  };
};
export {
  Bs as A,
  Fs as B,
  q as C,
  $t as D,
  cn as E,
  Xa as F,
  Ja as G,
  _s as L,
  Wa as O,
  pa as P,
  Ds as Q,
  Bt as S,
  g as T,
  Ge as U,
  lr as a,
  Vt as b,
  V as c,
  on as d,
  Tr as e,
  en as f,
  yr as g,
  Wr as h,
  Ve as i,
  _t as j,
  Be as k,
  ne as l,
  ir as m,
  zt as n,
  mt as o,
  Ha as p,
  Us as q,
  qe as r,
  $ as s,
  Dt as t,
  fa as u,
  Ls as v,
  or as w,
  we as x,
  $s as y,
  Qa as z
};
//# sourceMappingURL=index-C_PXQ8Bx.js.map
